webpackJsonp([1],{

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAutoupdate_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05468481_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAutoupdate_vue__ = __webpack_require__(422);
function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAutoupdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05468481_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAutoupdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Orbita-2-Logo.4eebc66.jpg";

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppAutoupdate_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppOfflineWarning_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderBand_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppPrivacy_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppAwaitingApproval_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SymptomEntry_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ResView_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppHelp_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__from_st_elsewhere_ActionSheet_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__from_st_elsewhere_SpinnerTrinity_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__ = __webpack_require__(56);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable standard/computed-property-even-spacing */












// These roots then have branches per user


var checkIntervalSeconds = 3600; // Every hour, reconsider whether we are up to date with data entry
var amOnlineSecondsBeforeCommenting = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // Subset of THIS variables that you want to be reactive on the template.
      // These must all be referred to as "this.", in the Methods.
      jsActiveLongEnoughToTellOnlineStatus: false,
      loggedState: undefined,
      amOnline: undefined,

      email: "",
      password: "",
      loginErr: {},
      showSpinner: false,

      user: {
        // Person A, the person ACTUALLY LOGGED IN (who might be the participant or a researcher at HQ)
        id: String,

        presenceRef: {},
        //    presenceObj: {}, // no point reading this
        //    presenceIsLoaded: Boolean, // no point reading this

        privilegesRef: {},
        privilegesObj: {
          participant: Boolean,
          blindedResearcher: Boolean,
          unblindedResearcher: Boolean
        },
        privilegesIsLoaded: Boolean
      },

      participantAndUserBranchBindingTable: {}, // keep a list of what you are binding to PARTICIPANT's branches, so you can unbind them when no longer needed (i.e. when binding something else).
      participant: {
        // List the branches of PARTICIPANT that we want to be reactive to
        id: "",

        statusRef: {},
        statusObj: {
          trained: false,
          refresh: "dummyStringReplacedWithRandom"
        },
        statusIsLoaded: false,

        contactRef: {},
        contactObj: {
          shortName: "",
          startDateKey: "",
          myAnginaIs: "",
          windows: {
            dates: [],
            questions: []
          }
        },
        contactIsLoaded: false,

        presenceRef: {},
        presenceObj: {},
        presenceIsLoaded: false,

        privilegesRef: {},
        privilegesObj: {
          participant: false,
          blindedResearcher: false,
          unblindedResearcher: false
        },
        privilegesIsLoaded: false
      }
    };
  },


  computed: {
    participantSufficientInfo: function participantSufficientInfo() {
      var sufficiency = {};

      sufficiency.privilegesParticipant = this.participant.privilegesObj && this.participant.privilegesObj.participant;

      sufficiency.statusPrivacy = this.participant.statusObj && this.participant.statusObj.privacy && this.participant.statusObj.privacy.agree && this.participant.statusObj.privacy.agreeDate;

      sufficiency.contactShortName = this.participant.contactObj && this.participant.contactObj.shortName;

      sufficiency.contactTrialId = this.participant.contactObj && this.participant.contactObj.trialId;

      sufficiency.contactStartDateKey = this.participant.contactObj && this.participant.contactObj.startDateKey;

      sufficiency.contactMyAnginaIs = this.participant.contactObj && this.participant.contactObj.myAnginaIs && this.participant.contactObj.myAnginaIs.length >= 4;

      sufficiency.contactWindowQuestions = this.participant.contactObj && this.participant.contactObj.windows && this.participant.contactObj.windows.questions && this.participant.contactObj.windows.questions.activity_001 && this.participant.contactObj.windows.questions.activity_001.length >= 3 && this.participant.contactObj.windows.questions.activity_002 && this.participant.contactObj.windows.questions.activity_002.length >= 3; // Arbitrarily require at least 3 characters for each activity. e.g. "run"

      sufficiency.all = sufficiency.privilegesParticipant && sufficiency.statusPrivacy && sufficiency.contactShortName && sufficiency.contactTrialId && sufficiency.contactStartDateKey && sufficiency.contactWindowQuestions;
      return sufficiency;
    }
  },
  firebase: {
    systemStatus: __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["j" /* systemStatusRef */]
  },
  components: {
    AppOfflineWarning: __WEBPACK_IMPORTED_MODULE_4__AppOfflineWarning_vue__["a" /* default */],
    HeaderBand: __WEBPACK_IMPORTED_MODULE_5__HeaderBand_vue__["a" /* default */],
    SymptomEntry: __WEBPACK_IMPORTED_MODULE_8__SymptomEntry_vue__["a" /* default */],
    ResView: __WEBPACK_IMPORTED_MODULE_9__ResView_vue__["a" /* default */],
    ActionSheet: __WEBPACK_IMPORTED_MODULE_11__from_st_elsewhere_ActionSheet_vue__["a" /* default */],
    SpinnerTrinity: __WEBPACK_IMPORTED_MODULE_12__from_st_elsewhere_SpinnerTrinity_vue__["a" /* default */],
    AppAwaitingApproval: __WEBPACK_IMPORTED_MODULE_7__AppAwaitingApproval_vue__["a" /* default */],
    AppPrivacy: __WEBPACK_IMPORTED_MODULE_6__AppPrivacy_vue__["a" /* default */],
    AppHelp: __WEBPACK_IMPORTED_MODULE_10__AppHelp_vue__["a" /* default */],
    AppAutoupdate: __WEBPACK_IMPORTED_MODULE_3__AppAutoupdate_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["c" /* auth */].onAuthStateChanged(function (user) {
      return _this.updateLoggedState(user);
    });

    setInterval(function () {}, checkIntervalSeconds * 1000);
  },

  methods: {
    tryLogin: function tryLogin(email, password) {
      var _this2 = this;

      this.showSpinner = true;
      __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["c" /* auth */].signInWithEmailAndPassword(email.trim(), password.trim()).then(function () {}).catch(function (e) {
        _this2.loginErr = e;
        throw new Error("Signin error:" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(e));
      }).finally(function () {
        _this2.showSpinner = false;
      });
    },
    trySignup: function trySignup(email, password) {
      var _this3 = this;

      this.showSpinner = true;

      __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["c" /* auth */].createUserWithEmailAndPassword(email.trim(), password.trim()).then(function () {}).catch(function (e) {
        return _this3.loginErr = e;
      }).finally(function () {
        _this3.showSpinner = false;
      });
    },
    trySignOut: function trySignOut() {
      var _this4 = this;

      this.showSpinner = true;
      __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["c" /* auth */].signOut().then(function () {}).catch(function (e) {
        return _this4.loginErr = e;
      }).finally(function () {
        _this4.showSpinner = false;
      });
    },
    tryForgotPassword: function tryForgotPassword(email) {
      var _this5 = this;

      if (!email.includes("@") || !email.includes(".")) {
        this.loginErr = {
          message: "Enter your email and press 'Forgot password' again."
        };
        return;
      }
      this.showSpinner = true;

      __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["c" /* auth */].sendPasswordResetEmail(email).then(function () {
        _this5.loginErr = {
          message: "We've just emailed you a password reset link. Please open your email and click the link from us."
        };
      }).catch(function (e) {
        return _this5.loginErr = e;
      }).finally(function () {
        _this5.showSpinner = false;
      });
    },
    updateLoggedState: function updateLoggedState(userFromAuth) {
      var _this6 = this;

      // Have to use this type of function definition and not fat arrow, because fat arrow fails to make "this" equal to the Vue instance

      // In the end I did this instead of vueFire, because it is not so difficult to do one's own firebase bindings

      // -------------------------------------------------
      // Set based on who is LOGGED IN:
      //    this.user.contactRef - firebase reference
      //    this.user.contactObj - read-only object that is live-updated from firebase
      //    this.user.contactIsLoaded - whether the conctactObj has had its first reading from firebase yet
      //    this.user.presenceRef
      //    this.user.presenceObj
      //    this.user.presenceIsLoaded
      //    this.user.privilegesRef
      //    this.user.privilegesObj
      //    this.user.privilegesIsLoaded
      //
      // Separately, set based on who THE TARGET PARTICIPANT IS:
      //    this.participant.contactRef
      //    this.participant.contactObj
      //    this.participant.contactIsLoaded
      //    this.participant.presenceRef
      //    this.participant.presenceObj
      //    this.participant.presenceIsLoaded
      //    this.participant.privilegesRef
      //    this.participant.privilegesObj
      //    this.participant.privilegesIsLoaded
      //    this.participant.statusRef
      //    this.participant.statusObj
      //    this.participant.statusIsLoaded
      //
      // For PARTICIPANTS, the USER and PARTICIPANT objects point to the same things (themselves).
      // For HQ staff, they have an identity themselves (and presence etc) but can look at participants' data
      // -------------------------------------------------

      if (userFromAuth) {
        this.password = ""; // remove password after login

        this.loggedState = "in";
        this.user.id = userFromAuth.uid;
        this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("user", this.user, "contact", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["d" /* contactRootRef */].child(this.user.id));
        this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("user", this.user, "presence", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["g" /* presenceRootRef */].child(this.user.id));
        this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("user", this.user, "privileges", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["h" /* privilegesRootRef */].child(this.user.id));
        this.user.presenceRef.update({
          dLastLogin: __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["a" /* ServerValueTIMESTAMP */],
          emailAtLastLogin: userFromAuth.email
        });
        __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["b" /* amOnlineRef */].on("value", function (snapshot) {
          if (snapshot.val()) {
            var instanceId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

            _this6.user.presenceRef.onDisconnect().update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
              lastChangeWasOn: null,
              lastWentOff: __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["a" /* ServerValueTIMESTAMP */]
            }, "currentSessions/" + instanceId, null));
            _this6.user.presenceRef.update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
              lastChangeWasOn: true
            }, "currentSessions/" + instanceId, true)).then(function () {
              _this6.amOnline = true;
            });
          } else {
            _this6.amOnline = false;
          }
        });
        setTimeout(function () {
          _this6.jsActiveLongEnoughToTellOnlineStatus = true;
        }, amOnlineSecondsBeforeCommenting * 1000);

        this.user.privilegesRef.on("value", function (dummySnapshot) {
          var numberOfPrivileges = (_this6.user.privilegesObj.participant ? 1 : 0) + (_this6.user.privilegesObj.blindedResearcher ? 1 : 0) + (_this6.user.privilegesObj.unblindedResearcher ? 1 : 0);

          if (numberOfPrivileges < 1) {
            _this6.errorState = {
              error: true,
              message: "Please ask the administrator to activate your account as a participant or a researcher. "
            };
            return;
          }
          if (numberOfPrivileges > 1) {
            _this6.errorState = {
              error: true,
              message: "You account has been mistakenly labelled as more than one type of user. Please ask the administrator to set your account as either a participant or a researcher, but not both."
            };
            return;
          }

          // Now we know there is only 1 privilege

          if (_this6.user.privilegesObj.participant) {
            _this6.bindParticipantToAUserId(_this6.user.id);
          } else {
            // They are a researcher, and will get their own web page which calls "bindParticipantToAUserId" when they select a participant
          }
        });
      } else {
        this.loggedState = "out";
      }
    },
    bindParticipantToAUserId: function bindParticipantToAUserId(aParticipantsUserId) {
      this.participant.id = aParticipantsUserId;

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("participant", this.participant, "contact", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["d" /* contactRootRef */].child(aParticipantsUserId));

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("participant", this.participant, "status", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["i" /* statusRootRef */].child(aParticipantsUserId));

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("participant", this.participant, "presence", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["g" /* presenceRootRef */].child(aParticipantsUserId));

      this.bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED("participant", this.participant, "privileges", __WEBPACK_IMPORTED_MODULE_13__firebaseSetup_js__["h" /* privilegesRootRef */].child(aParticipantsUserId));
    },
    bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED: function bindBranchToThisParticipantOrThisUserAsREFandOBJandISLOADED(participantOrUserString, participantOrUserObject, keyPrefix, firebaseRef) {
      // "keyPrefix" can be, for example, "status"
      // That would create in participant, te efollowing:
      //   participant.statusRef    which would be the firebase Ref for the participant's status
      //   participant.statusObj    which would be the firebase-bound status
      //   participant.statusIsLoaded    which would be true once firebase first reads the data into the object

      // Step 1. Open up the pathway to that point in the table
      if (!this.participantAndUserBranchBindingTable) {
        this.participantAndUserBranchBindingTable = {};
      }
      if (!this.participantAndUserBranchBindingTable[participantOrUserString]) {
        this.participantAndUserBranchBindingTable[participantOrUserString] = {};
      }

      // Step 2. If this variable is already bound to a firebase node, unbind
      if (this.participantAndUserBranchBindingTable[participantOrUserString][keyPrefix]) {
        // If this keyPrefix is already bound to a firebase node, unbind it. Otherwise updates to teh OLD node will wrongly cause themselves to be read in and trigger an incorrect "update" to the new node, i.e. overwrite your new patient's data with the previous patient's data (just because the previous patient happened to update their data)
        this.participantAndUserBranchBindingTable[participantOrUserString][keyPrefix].off();
        participantOrUserObject[keyPrefix + "IsLoaded"] = false;
      }

      // Step 3. Now bind to the new firebase node and store the three things, "REF","OBJ" itself, and "ISLOADED".
      this.participantAndUserBranchBindingTable[participantOrUserString][keyPrefix] = firebaseRef;
      participantOrUserObject[keyPrefix + "Ref"] = firebaseRef;

      firebaseRef.on("value", function (snapshot) {
        // Every time firebase value changes (including the first where firebase just comes live) this will cause an Object.assign, causing a re-render of the object in this and the children components.

        var newKeyValuePair = {};
        var newValue = snapshot.val() || {};

        if (keyPrefix === "contact") {
          // Ensure contact has these branches
          if (!newValue.windows) {
            newValue.windows = {};
          }
          if (!newValue.windows.dates) {
            newValue.windows.dates = {};
          }
          if (!newValue.windows.questions) {
            newValue.windows.questions = {};
          }
        }

        newKeyValuePair[keyPrefix + "Obj"] = newValue;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(participantOrUserObject, newKeyValuePair);

        participantOrUserObject[keyPrefix + "IsLoaded"] = true;
      });
    }
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_st_elsewhere_BuildVersion_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebaseSetup_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilGetNewest_js__ = __webpack_require__(315);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // This is overwritten by the building process



 // but remember to also re-export it in methods

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    canUpdateNow: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      runningVersion: __WEBPACK_IMPORTED_MODULE_0__from_st_elsewhere_BuildVersion_js__["a" /* BUILDVERSION */],
      latestVersion: "",
      latestVersionRead: false
    };
  },
  computed: {
    runningVersionRelative: function runningVersionRelative() {
      if (this.latestVersionRead) {
        if (this.runningVersion > this.latestVersion) {
          return +1; // The version running is NEWER than the one listed on firebase, which will happen if you have half-run the build script and then aborted it (or while it runs) are serving it locally via NPM RUN DEV.
        } else if (this.runningVersion < this.latestVersion) {
          if (this.canUpdateNow) {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(__WEBPACK_IMPORTED_MODULE_2__utilGetNewest_js__["a" /* getNewest */], 10000);
          }
          return -1; // The version running is OLDER than the one listed on firebase, which means you should update
        } else {
          return 0; // You are up to date
        }
      }
      return undefined;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__firebaseSetup_js__["j" /* systemStatusRef */].on("value", function (snapshot) {
      _this.latestVersion = (snapshot.val() || {}).latestVersion;
      _this.latestVersionRead = true;
    });
  },

  methods: {
    getNewest: __WEBPACK_IMPORTED_MODULE_2__utilGetNewest_js__["a" /* getNewest */] // This is just a re-export so the imported function which went into the global space (that can't be seen by the template) is re-exported as this.getNewest, so it *can* be seen by the template.
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILDVERSION; });
var BUILDVERSION = "2022-05-10,12:13:17"; // This line was autocreated by the batch script "C:\Users\darre\Dropbox\Sh\O2A Orbita-2 Outer\!O2A Build (incl VERSION) & deploy HOSTING .cmd"  at the time of the last build, and is used for the auto-updating feature.

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNewest;
function getNewest() {
  window.location.reload(true);
}

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBand_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c45d00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBand_vue__ = __webpack_require__(427);
function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c45d00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: false
    },
    email: { type: String, required: false },
    trialId: { type: String, required: false },
    privileges: { type: Object, required: false }
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    displayName: String,
    participantSufficientInfo: Object
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SymptomEntry_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c191916_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SymptomEntry_vue__ = __webpack_require__(468);
function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SymptomEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c191916_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SymptomEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseSetup_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppAutoupdate_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ErrorPracticeWrongAnswer_vue__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__from_st_elsewhere_SpinnerTrinity_vue__ = __webpack_require__(336);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable indent */
/* eslint-disable standard/computed-property-even-spacing */






// https://www.sitepoint.com/use-html5-vibration-api/
navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
if (navigator.vibrate) {
  // vibration API supported
}

var platform = __webpack_require__(466);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppAutoupdate: __WEBPACK_IMPORTED_MODULE_6__AppAutoupdate_vue__["a" /* default */],
    SpinnerTrinity: __WEBPACK_IMPORTED_MODULE_8__from_st_elsewhere_SpinnerTrinity_vue__["a" /* default */],
    ErrorPracticeWrongAnswer: __WEBPACK_IMPORTED_MODULE_7__ErrorPracticeWrongAnswer_vue__["a" /* default */]
  },

  props: {
    // Received from parent. Do not mutate because if the parent changes a variable, it will re-render and lose your mutation.
    participant: {
      contactRef: {},
      contactObj: {},
      statusObj: {},
      statusIsLoaded: null
    },
    entryMode: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ["live", "practice"].includes(value);
      }
    }
  },

  data: function data() {
    // Local data that we need to trigger re-rendering.
    return {
      liveOrPractice: "",
      date: {
        // We will calculate missing missing day-by-day date and stick in here.
      },
      missingWindow: {
        // we will calculate the missing window and stick in here
      },

      symptomEntryProgress: {
        // Optional declaration of what's in it, for documentation purposes
        upToDate: {
          all: false,
          days: false,
          windows: false
        },
        theresMore: false
      },
      sliderInitialInvalidValue: 0, // this is like a CONST that the sliderValue is set to each time rather than being zeroed. It is in the acceptable range, to avoid an error by VueSlider component, but also a fraction, so we can recognise it as invalid and NOT show the OK button until the user jiggles it a bit
      sliderValue: 0,

      errorWrongPracticeAnswer: false
    };
  },

  computed: {
    rangeMidPc: function rangeMidPc() {
      return 0;
    },
    rangeLeftPc: function rangeLeftPc() {
      return this.sliderValue / 600 * 100 - this.rangeMidPc / 2;
    },
    rangeRightPc: function rangeRightPc() {
      return 100 - this.rangeMidPc - this.rangeLeftPc;
    }
  },

  created: function created() {
    var _this = this;

    this.startSymptomEntryComponentAfresh();

    this.participant.statusRef.child("trained").on("value", function () {
      setTimeout(_this.startSymptomEntryComponentAfresh, 10);
    }); // If the "isTrained" is changed

    this.participant.statusRef.child("refresh").on("value", function (a) {
      // This is superfluous on a local system but if logged in on two systems, or staff & patient logged on at two different places, looking at the same participant record, it ensures that when the date needs to be recalculated, it is done and screen updated.

      _this.savedSoPleaseRecalculateMissingDaysAndWindows(false /* no spinner */
      );
    });
  },

  methods: {
    triggerParticipantScreenRefresh: function triggerParticipantScreenRefresh() {
      // DUPLICATED -- naughtily --- in RESVIEW
      // this is picked up by the firebase "ON" on the refresh node and triggers this.startSymptomEntryComponentAfresh() at the end of a setTimeout (to let the digest finish)
      this.participant.statusRef.child("refresh").set(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    },

    validAnginaSeverity: function validAnginaSeverity(severity) {
      var sev = parseFloat(severity);
      return sev === parseInt(sev) && sev >= 1 && sev <= 600 && sev !== this.sliderInitialInvalidValue;
    },

    resetSlider: function resetSlider() {
      this.sliderValue = this.sliderInitialInvalidValue;
    },

    startSymptomEntryComponentAfresh: function startSymptomEntryComponentAfresh() {
      var _this2 = this;

      // This makes it calculate when the component starts. The tag in the parent that calls the component has a v-if that only allows the component to be created when statusObj[liveOrPractice] is loaded by firebase. That is important otherwise the target date calculation will not see any data

      if (this.entryMode === "practice") {
        this.liveOrPractice = "practice";

        var recentDates = this.calcTodayYesterdayDayBeforeYesterdayKeys();

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.writeAndLog(this.participant.statusRef.child("practice").child("days").child(recentDates.dayBeforeYesterdayKey), null), this.writeAndLog(this.participant.statusRef.child("practice").child("days").child(recentDates.yesterdayKey), null), this.writeAndLog(this.participant.statusRef.child("practice").child("windows"), null)]).then(function () {
          // Set up this component for practice
          var targetDateAndUpToDateness = _this2.calcTargetDateAndUpToDateness(recentDates.dayBeforeYesterdayKey, (_this2.participant.statusObj || {})[_this2.liveOrPractice], _this2.participant.contactObj || {});
          _this2.symptomEntryProgress.upToDate = targetDateAndUpToDateness.upToDate;
          _this2.date = targetDateAndUpToDateness.date;
          _this2.missingWindow = targetDateAndUpToDateness.missingWindow;
        });
      } else {
        // Set up this component for live
        this.liveOrPractice = "live";

        var targetDateAndUpToDateness = this.calcTargetDateAndUpToDateness(this.participant.contactObj.startDateKey, (this.participant.statusObj || {})[this.liveOrPractice], this.participant.contactObj || {});
        this.symptomEntryProgress.upToDate = targetDateAndUpToDateness.upToDate;
        this.date = targetDateAndUpToDateness.date;
        this.missingWindow = targetDateAndUpToDateness.missingWindow;
      }
    },

    startDateKeyLiveOrPractice: function startDateKeyLiveOrPractice() {
      return this.entryMode === "practice" ? this.calcTodayYesterdayDayBeforeYesterdayKeys().dayBeforeYesterdayKey : this.participant.contactObj.startDateKey || "2001-01-01";
    },
    calcTodayYesterdayDayBeforeYesterdayKeys: function calcTodayYesterdayDayBeforeYesterdayKeys() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // options:
      //   debugLogIt: write to log or not

      var date = {};
      var debugItem = {};

      var spacesForVisibilityInFirebaseConsole = "     ⬛⬛"; // so can read in firebase console which truncates last bit

      debugItem["A"] = "PARTICIPANT " + this.participant.contactObj.shortName + " " + this.participant.contactObj.trialId + ", start date " + this.participant.contactObj.startDateKey + spacesForVisibilityInFirebaseConsole;

      debugItem["A1"] = platform.description + spacesForVisibilityInFirebaseConsole;

      debugItem["B"] = "Confirming that the KEYS are definitely correct" + spacesForVisibilityInFirebaseConsole;
      debugItem["B01"] = "new Date().toISOString() is " + new Date().toISOString() + spacesForVisibilityInFirebaseConsole;

      date.todayKey = new Date().toISOString().slice(0, 10);
      debugItem["B02"] = "date.todayKey set to " + date.todayKey + spacesForVisibilityInFirebaseConsole;

      date.yesterday = new Date();
      date.yesterday.setDate(date.yesterday.getDate() - 1);
      date.yesterdayKey = date.yesterday.toISOString().slice(0, 10);

      date.dayBeforeYesterday = new Date();
      date.dayBeforeYesterday.setDate(date.dayBeforeYesterday.getDate() - 2);
      date.dayBeforeYesterdayKey = date.dayBeforeYesterday.toISOString().slice(0, 10);

      debugItem["D"] = "The problem was in date DISPLAY. Now switched to LUXON." + spacesForVisibilityInFirebaseConsole;

      debugItem["D1"] = "Using Intl.DateTime, today is " + this.insanePieceOfShit(date.todayKey) + spacesForVisibilityInFirebaseConsole;
      debugItem["D2"] = "Using Luxon, today is " + this.formatDateWwwDdMm(date.todayKey) + spacesForVisibilityInFirebaseConsole;
      debugItem["D3"] = this.formatDateWwwDdMm(date.todayKey) === this.insanePieceOfShit(date.todayKey) ? "OK" : "OMG! WTF?!?!?!! F**ing Intl.DateTime" + spacesForVisibilityInFirebaseConsole;

      var debugKey = new Date() // Date to the millisecond plus 8 random hex digits
      .toISOString().replace("T", "@").replace(/:/g, "-")
      // Actually there is a huge number of these. We will save log overload by writing to a node by the second (not millisecond)
      .split(".")[0];
      //          .replace(".", "_") + Math.floor(Math.random() * 2 ** 32).toString(16);

      if (options.debugLogIt) {
        __WEBPACK_IMPORTED_MODULE_5__firebaseSetup_js__["e" /* debugRootRef */].child("dateFiasco").child(__WEBPACK_IMPORTED_MODULE_5__firebaseSetup_js__["c" /* auth */].currentUser.uid).child(debugKey).set(debugItem);
      }
      return date;
    },
    dateObjToKey: function dateObjToKey(dateObj) {
      return dateObj.toISOString().slice(0, 10);
    },
    calcDateKeyPlusDeltaDays: function calcDateKeyPlusDeltaDays(key, deltaDays) {
      var dateObj = new Date(key);
      dateObj.setDate(dateObj.getDate() + deltaDays);
      return this.dateObjToKey(dateObj);
    },
    calcDaysBetweenDateKeysInclusive: function calcDaysBetweenDateKeysInclusive(startKey, endKeyInclusive) {
      var daysDifferentExclusive = Math.round((Date.parse(endKeyInclusive) - Date.parse(startKey)) / 86400000);
      return 1 + daysDifferentExclusive;
    },
    calcDateKeyListBetweenDateKeysInclusive: function calcDateKeyListBetweenDateKeysInclusive(startKey, endKeyInclusive) {
      var iDate = new Date(startKey);
      var dateKey = this.dateObjToKey(iDate);
      var dateKeyList = [];
      while (dateKey <= endKeyInclusive) {
        dateKeyList.push(dateKey);
        iDate.setDate(iDate.getDate() + 1);
        dateKey = this.dateObjToKey(iDate);
      }
      return dateKeyList;
    },
    formatDateWwwDdMm: function formatDateWwwDdMm(dateKey) {
      // This uses Luxon because Intl DateTime is shit
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(dateKey + "T12:00:00Z").toFormat("ccc d LLL").replace(/ /g, "\xA0"); // &nbsp; to stop date being split by word wrap
    },
    formatDateDdMmYyyy: function formatDateDdMmYyyy(dateKey) {
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(dateKey + "T12:00:00Z").toFormat("d LLL yyyy").replace(/ /g, "\xA0");
    },
    insanePieceOfShit: function insanePieceOfShit(dateKey) {
      // Don't use this heap of shit: is sometimes showing one day out (some phones! not most):
      var dateFormatterObject = {
        weekday: "short",
        day: "numeric",
        month: "short"
      };
      return Intl.DateTimeFormat("en-GB", dateFormatterObject).format(new Date(dateKey)).replace(/ /g, "\xA0");
    },
    calcTargetDateAndUpToDateness: function calcTargetDateAndUpToDateness(startDateKey, statusObj, contactObj) {
      var _this3 = this;

      // Calculates:
      //     Target Date for the day-by-day data entry
      //     Windows of time needing entry (e.g. weekly)
      //     Whether we are all up to date.
      //     Incidentally returns the current, and last two, date Keys

      // Called every time we come on line, and by a timer every (currently) one hour, and every time they save a day's worth of data
      var date = this.calcTodayYesterdayDayBeforeYesterdayKeys({
        debugLogIt: true
      }); // Object into which we will inject target date info, and todays date

      // DAY BY DAY data ---------------------------------------------------------------

      var foundAnyMissingDayByDayData = false;
      var iDayChecked = 0;
      var iDateKey = startDateKey;
      var newDate = new Date(); // Dummy value to be overwritten during search

      while (iDateKey < date.todayKey && !foundAnyMissingDayByDayData && iDayChecked < 1e5) {
        // Check
        if (!statusObj || !statusObj.days || !statusObj.days[iDateKey] || !statusObj.days[iDateKey].saved) {
          foundAnyMissingDayByDayData = true;
          date.targetKey = iDateKey;
        } else {
          // Next
          iDayChecked++;
          newDate = new Date(iDateKey);
          newDate.setTime(newDate.getTime() + 1000 * 60 * 60 * (24 + 2)); // Not just add one to day! Otherwise will get trapped when clocks go forward at Easter
          iDateKey = newDate.toISOString().slice(0, 10);
        }
      }

      if (foundAnyMissingDayByDayData) {
        date.target = new Date(date.targetKey);
        var daysDifferent = Math.round((new Date(date.todayKey) - date.target) / 86400e3);
        if (daysDifferent < 30) {
          date.targetDisplayString = this.formatDateWwwDdMm(date.targetKey);
        } else {
          date.targetDisplayString = this.formatDateDdMmYyyy(date.targetKey);
        }

        if (daysDifferent === 1) {
          date.targetDisplayStringWithComment = "Yesterday, " + date.targetDisplayString + ":";
        } else if (daysDifferent === 2) {
          date.targetDisplayStringWithComment = "The day before yesterday, " + date.targetDisplayString + ":";
        } else {
          date.targetDisplayStringWithComment = "On " + date.targetDisplayString + ":";
        }
      }
      // WINDOW (e.g. weekly) data ---------------------------------------------------------

      var windowsDatesObj = {};
      var windowsQuestionsObj = {};

      windowsQuestionsObj = contactObj && contactObj.windows && contactObj.windows.questions || {};
      if (this.liveOrPractice === "practice") {
        windowsDatesObj = { dummyD1: { endDateKey: date.yesterdayKey } };
      } else {
        // "live" or being run by HQ
        windowsDatesObj = contactObj && contactObj.windows && contactObj.windows.dates || {};
      }

      // unpack window DATES
      var windowsDatesIdsArray = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(windowsDatesObj);
      var windowsDatesArray = windowsDatesIdsArray.map(function (windowsDateKey) {
        var thing = windowsDatesObj[windowsDateKey];
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(thing, { key: windowsDateKey });
        return thing;
      });

      // unpack window QUESTIONS
      var windowsQuestionsIdsArray = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(windowsQuestionsObj);
      var windowsQuestionsArray = windowsQuestionsIdsArray.map(function (windowsQuestionKey) {
        return {
          whenYou: windowsQuestionsObj[windowsQuestionKey],
          key: windowsQuestionKey
        };
      });

      // Now we know what they should have done, and when they should have reported. Look to see if all past windows have full data.
      var runningStartDateKeyInCaseNotStoredInContacts = startDateKey; // The windows CAN be disjoint but it is more usual to have them end-to-end, so you only have to state the END date (last date of symptom; date of recording is next day). The first date is taken as the day after the last date of the previous window, except for the first window, which starts at the start date.
      //      ### TEST FOR OVERLAPPING  ---- TODO
      var foundAnyMissingWindowData = false;
      var missingWindow = {};

      var _loop = function _loop(iWindow) {
        var windowKey = windowsDatesArray[iWindow].key; // This is the key in the window OBJECT, e.g. fgdf9g6df8g97d6fg98f76g89, not a date key like 2018-10-16
        var endKey = windowsDatesArray[iWindow].endDateKey;
        var startKey = windowsDatesArray[iWindow].startDateKey || runningStartDateKeyInCaseNotStoredInContacts;

        windowsQuestionsArray.forEach(function (questionObj) {
          var answerObject = ((((statusObj || {}).windows || {})[windowKey] || {}).questions || {})[questionObj.key];
          if (!foundAnyMissingWindowData && date.todayKey > endKey && !answerObject) {
            foundAnyMissingWindowData = true;
            missingWindow.windowKey = windowKey;
            missingWindow.question = questionObj;
            missingWindow.endDateKey = windowsDatesArray[iWindow].endDateKey;
            missingWindow.startDateKey = startKey;

            missingWindow.startDateDisplay = _this3.formatDateWwwDdMm(missingWindow.startDateKey);
            missingWindow.endDateDisplay = _this3.formatDateWwwDdMm(missingWindow.endDateKey);
            missingWindow.durationDaysInclusive = _this3.calcDaysBetweenDateKeysInclusive(missingWindow.startDateKey, missingWindow.endDateKey);
          }

          runningStartDateKeyInCaseNotStoredInContacts = _this3.calcDateKeyPlusDeltaDays(endKey, 1); // for next cycle through loop, for next window
        });
      };

      for (var iWindow = 0; iWindow < windowsDatesIdsArray.length; iWindow++) {
        _loop(iWindow);
      }
      // OK got the answers for both day-by-day and windows

      if (date.targetKey) {
        // Need to store for HQ the COMPLETED dates, taking into account both daily and weekly requirements for data. Can't just store target because if the participant is off line we don't want HQ to assume they are up to date

        // Option 1. A missing DAILY DATA item
        date.completeToDateKey = this.calcDateKeyPlusDeltaDays(date.targetKey, -1);
      } else if (foundAnyMissingWindowData) {
        // Option 2. A missing WINDOW DATA item
        date.completeToDateKey = this.calcDateKeyPlusDeltaDays(missingWindow.endDateKey, -1);
      } else {
        // Option 3. Nothing missing! Yay!
        date.completeToDateKey = this.calcDateKeyPlusDeltaDays(date.todayKey, -1);
      }

      var returnObj = {
        upToDate: {
          days: !foundAnyMissingDayByDayData,
          windows: !foundAnyMissingWindowData,
          all: !foundAnyMissingDayByDayData && !foundAnyMissingWindowData
        },
        date: date, // contains: {        todayKey, yesterdayKey, dayBeforeYesterdayKey,       targetKey,        target,        targetDisplayString,      targetDisplayStringWithComment, completeToDateKey   },
        missingWindow: missingWindow // either empty or contains: key, startDateKey, endDateKey, startDateDisplay, endDateDisplay, durationDaysInclusive,

        // for display at HQ
      };

      return returnObj;
    },


    writeAndLog: function writeAndLog(ref, value) {
      var _this4 = this;

      var isSavingOfADayOrWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // SELF-CONTAINED
      // Presence of isSavingOfADayOrWindow means that we want to test validity of the dataset
      var subPath = ref.toString().substring(ref.root.toString().length);
      var valueToStoreInLog = value === null ? "(cleared)" : value;
      var logItem = {
        at: __WEBPACK_IMPORTED_MODULE_5__firebaseSetup_js__["a" /* ServerValueTIMESTAMP */],
        by: __WEBPACK_IMPORTED_MODULE_5__firebaseSetup_js__["c" /* auth */].currentUser.uid,
        to: valueToStoreInLog
      };
      var newLogItemKey = __WEBPACK_IMPORTED_MODULE_5__firebaseSetup_js__["f" /* logRootRef */].child(subPath).push();

      //      this.hapticFeedback();

      // These 2 below could be made into simultaneous, and checked server-side - TODO#

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([newLogItemKey.set(logItem), ref.set(value)]).then(function () {
        _this4.triggerParticipantScreenRefresh(); // This updates the "refresh" key in the "presence" tag so that everyone viewing this patient's data through this component knows to refresh their screen, solely to show the newly entered data (not to go on to the next data entry etc)

        _this4.testAndUpdateValidityDaysP(_this4.date.targetKey).then(function () {
          if (isSavingOfADayOrWindow) {
            _this4.savedSoPleaseRecalculateMissingDaysAndWindows(true /* show spinner */
            );
            _this4.triggerParticipantScreenRefresh(); // This does it again, now that we have advanced on to the next day etc
          }
        });
      }).catch(function (e) {
        console.error(e, "Error in writing (main or log) for path:" + subPath + "the value:" + value);
      });
    },

    hapticFeedback: function hapticFeedback() {
      // As of 2018, only works on Android not iOS
      if (navigator.vibrate) {
        navigator.vibrate([10]);
      }
    },

    testAndUpdateValidityDaysP: function testAndUpdateValidityDaysP(targetDateKey) {
      if (targetDateKey) {
        var validity = !!this.participant && !!this.participant.statusObj && !!this.participant.statusObj[this.liveOrPractice] && !!this.participant.statusObj[this.liveOrPractice].days && !!this.participant.statusObj[this.liveOrPractice].days[targetDateKey] && (this.participant.statusObj[this.liveOrPractice].days[targetDateKey].anginaYesNo === "No" || this.participant.statusObj[this.liveOrPractice].days[targetDateKey].anginaYesNo === "Yes" && this.participant.statusObj[this.liveOrPractice].days[targetDateKey].anginaCount && this.validAnginaSeverity(this.participant.statusObj[this.liveOrPractice].days[targetDateKey].anginaSeverity));
        return this.participant.statusRef.child(this.liveOrPractice).child("days").child(targetDateKey).child("validClient").set(validity ? true : null);
      } else {
        // If there is no targetDate, i.e. all the day-by-day answers are done, then just return as a resolved promise
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
      }
    },

    savedSoPleaseRecalculateMissingDaysAndWindows: function savedSoPleaseRecalculateMissingDaysAndWindows(showSpinnerForAShortTime) {
      var _this5 = this;

      // When you KNOW you have updated to go to a new day, on this browser, i.e. you are the person entering it, set showSpinnerForAShortTime to true.
      // When you KNOW you are NOT the person updating the page (or you are reacting secondarily to a REFRESH command you sent to everyone including yourself), don't show the spinner

      // Step 1. Show spinner

      if (showSpinnerForAShortTime) {
        this.symptomEntryProgress.theresMore = true;
        // now force reaction
        this.symptomEntryProgress = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.symptomEntryProgress));
      }

      this.$nextTick().then(function () {
        // DOM updated
        // Step 2. After leaving a few milliseconds for the screen to blank with the spinner, calculate the new dates and windows
        setTimeout(function () {
          var targetDateAndUpToDateness = _this5.calcTargetDateAndUpToDateness(_this5.startDateKeyLiveOrPractice(), _this5.participant.statusObj[_this5.liveOrPractice], _this5.participant.contactObj || {});

          _this5.symptomEntryProgress.upToDate = targetDateAndUpToDateness.upToDate;
          _this5.date = targetDateAndUpToDateness.date;
          _this5.missingWindow = targetDateAndUpToDateness.missingWindow;

          var summary = {
            upToDateClient: targetDateAndUpToDateness.upToDate,
            completeToDateKey: targetDateAndUpToDateness.date.completeToDateKey || null
          };
          // Duplicate writing here so that can be sorted without reading whole Status Object
          _this5.participant.statusRef.child("progress").update(summary);
          _this5.participant.presenceRef.child("progress").update(summary);
        }, 500);

        // Step 3 (inside the nextTick promise) Now remove the spinner.
        if (showSpinnerForAShortTime) {
          setTimeout(function () {
            _this5.symptomEntryProgress.theresMore = false;
            // now force reaction
            _this5.symptomEntryProgress = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.symptomEntryProgress));
          }, 1000);
        }
      });
    },

    practiceAnswersCorrect_givenValidClientAndPractice: function practiceAnswersCorrect_givenValidClientAndPractice() {
      if (this.date.targetKey === this.date.dayBeforeYesterdayKey) {
        return this.participant.statusObj[this.liveOrPractice].days[this.date.targetKey].anginaYesNo === "Yes" && this.participant.statusObj[this.liveOrPractice].days[this.date.targetKey].anginaCount === 2 && this.participant.statusObj[this.liveOrPractice].days[this.date.targetKey].anginaSeverity >= 200 && this.participant.statusObj[this.liveOrPractice].days[this.date.targetKey].anginaSeverity <= 399;
      }

      if (this.date.targetKey === this.date.yesterdayKey) {
        return (
          // eslint-disable-next-line
          this.participant.statusObj[this.liveOrPractice].days[this.date.targetKey].anginaYesNo === "No"
        );
      }
    },

    showPracticeInputErrorNotificationBriefly: function showPracticeInputErrorNotificationBriefly(activate) {
      var _this6 = this;

      if (activate) {
        var currentErrorInstanceStartTime = new Date().toISOString();
        this.errorWrongPracticeAnswerLast = currentErrorInstanceStartTime;
        this.errorWrongPracticeAnswer = true;
        setTimeout(function () {
          if (_this6.errorWrongPracticeAnswerLast === currentErrorInstanceStartTime) {
            // only hide the error message if this "hide" timeout belongs to the last error message that has been issued. This way, if you have two errors in rapid succession, the HIDE of the FIRST error cannot hide the message of the SECOND error, which causes an awkward flitting of the second error message on and off.
            _this6.errorWrongPracticeAnswer = false;
          }
        }, 10000);
      } else {
        this.errorWrongPracticeAnswer = false;
      }
    },
    checkAndWriteAnswerToDailyAnginaYesNoQuestion: function checkAndWriteAnswerToDailyAnginaYesNoQuestion(yesOrNo) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (this.liveOrPractice === "live" || // or in PRACTICE phase, where only particular answers are acceptable
      this.date.targetKey === this.date.dayBeforeYesterdayKey && yesOrNo === "Yes" || this.date.targetKey === this.date.yesterdayKey && yesOrNo === "No") {
        this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("anginaYesNo"), yesOrNo);

        this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("anginaCount"), null);

        this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("anginaSeverity"), this.sliderInitialInvalidValue);

        if (yesOrNo === "No") {
          // If this is a "NO" angina, then go straight ahead and save. Nothing to wait for.
          this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("saved"), true /* actual thing to write */
          , true /* flag to recalc dates */
          );
        }
      } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },
    checkAndWriteAnswerToFrequencyQuestion: function checkAndWriteAnswerToFrequencyQuestion(count) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (this.liveOrPractice === "live" || count === 2 /* i.e. for PRACTICE mode, the example case is 2 episodes */
      ) {
          this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("anginaCount"), count);
          // Stops "wrong answer" message from persisting if the user quickly re-answers correctly
        } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },
    checkAndWriteAnswerToSeverityQuestion: function checkAndWriteAnswerToSeverityQuestion(sliderValue) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (this.liveOrPractice === "live" || sliderValue >= 200 && sliderValue <= 399 /* i.e. for PRACTICE mode, you need to be in the MODERATE zone */
      ) {
          this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("anginaSeverity"), sliderValue);

          this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("days").child(this.date.targetKey).child("saved"), true /* value being written */
          , true /* says this is the saving a whole day's data, so triggering a recalc of target date and weeks */
          );
          this.errorWrongPracticeAnswer = false; // Stops "wrong answer" message from persisting if the user quickly re-answers correctly
        } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },
    checkAndWriteAnswerToWindowQuestion: function checkAndWriteAnswerToWindowQuestion(answer) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (this.liveOrPractice === "live" || this.missingWindow.question.key === "activity_001" && answer === "No" || this.missingWindow.question.key === "activity_002" && answer === "Yes") {
        this.writeAndLog(this.participant.statusRef.child(this.liveOrPractice).child("windows").child(this.missingWindow.windowKey).child("questions").child(this.missingWindow.question.key).child("anginaYesNo"), answer, true);
      } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    }
  } /* closing brace for 'methods' */
}); /* closing brace for export default */

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerTrinity_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_645b6fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerTrinity_vue__ = __webpack_require__(465);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerTrinity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_645b6fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerTrinity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SymptomEntry_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResViewNewParticipantHelp_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderBand_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MyAnginaIs_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ResViewAnginaTrigger_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AppAutoupdate_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DataExport_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__firebaseSetup_js__ = __webpack_require__(56);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable standard/computed-property-even-spacing */











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SymptomEntry: __WEBPACK_IMPORTED_MODULE_3__SymptomEntry_vue__["a" /* default */],
    ResViewNewParticipantHelp: __WEBPACK_IMPORTED_MODULE_4__ResViewNewParticipantHelp_vue__["a" /* default */],
    HeaderBand: __WEBPACK_IMPORTED_MODULE_5__HeaderBand_vue__["a" /* default */],
    MyAnginaIs: __WEBPACK_IMPORTED_MODULE_6__MyAnginaIs_vue__["a" /* default */],
    ResViewAnginaTrigger: __WEBPACK_IMPORTED_MODULE_7__ResViewAnginaTrigger_vue__["a" /* default */],
    AppAutoupdate: __WEBPACK_IMPORTED_MODULE_8__AppAutoupdate_vue__["a" /* default */],
    DataExport: __WEBPACK_IMPORTED_MODULE_9__DataExport_vue__["a" /* default */]
  },

  props: ["user", "participant", "bindParticipantToAUserId"],

  data: function data() {
    return {
      mode: "home", // "overview","onboardingList","onboardingOne","monitorList","monitorOne"

      contactRootObj: {},
      privilegesRootObj: {},
      presenceRootObj: {},
      presenceRootArray: [],
      presenceRootArrayEligibleForOnboarding: [],
      // statusRootObj: {},
      statusRootRef: __WEBPACK_IMPORTED_MODULE_10__firebaseSetup_js__["i" /* statusRootRef */],
      participantIdArray: [],
      participantMingledArray: [],
      // PRIVILEGES, CONTACTS, PRESENCE datasets, which are small enough to hold for all patients in memory at once, but not STATUS which is too large volume to hold everyone's at once.

      onlyShowOrbita2: true,
      onlyShowIncomplete: true,

      fieldsOnboarding: [{
        key: "emailAtLastLogin",
        label: "Email",
        sortable: true,
        class: "tableEmail",
        formatter: function formatter(email) {
          return (email || "No email").replace("@", "\u200A@\u200A");
        }
      }, { key: "trialId", sortable: true }, {
        key: "dLastLogin",
        formatter: function formatter(serverTimeInt) {
          return new Intl.DateTimeFormat("en-GB", {
            hour: "numeric",
            minute: "numeric",
            timeZoneName: "short",
            day: "numeric",
            month: "short",
            year: "2-digit"
          }).format(new Date(serverTimeInt || 0));
        },
        label: "Last refreshed",
        sortable: true,
        class: "tableDate"
      }],

      fieldsMonitor: [{
        key: "completeToDateKey",
        sortable: true,
        label: "Done up to"
      }, { key: "trialId", sortable: true },
      //      { key: "emailAtLastLogin", label: "Email", sortable: true },
      // {
      //   key: "lastChangeWasOn",
      //   formatter: value => (value ? "On" : "-"),
      //   label: "Online?",
      //   sortable: true
      // },
      // {
      //   key: "dLastLogin",
      //   formatter: serverTimeInt =>
      //     new Intl.DateTimeFormat("en-GB", {
      //       hour: "numeric",
      //       minute: "numeric",
      //       timeZoneName: "short",
      //       day: "numeric",
      //       month: "short",
      //       year: "2-digit"
      //     }).format(new Date(serverTimeInt || 0)),
      //   label: "Last refreshed",
      //   sortable: true
      // },
      {
        key: "actions"
        /* This will be filled in with the action buttons in the template */
      }],

      datePickerFormats: {
        input: ["YYYY-MM-DD"],
        data: ["YYYY-MM-DD"],
        dayPopover: "L"
      },

      showNewParticipantHelp: false
    };
  },

  computed: {
    presenceArrayEligibleForOnboarding: function presenceArrayEligibleForOnboarding() {
      var _this = this;

      var todayKey = new Date().toISOString().slice(0, 10);

      var presenceRootArraySubset = this.presenceRootArray.filter(function (presenceItem) {
        var id = presenceItem.id;

        var p = _this.contactRootObj[id] || { shortName: "No name" };
        var isResearcher = // and therefore not eligible to be onboarded
        _this.privilegesRootObj[id] && (_this.privilegesRootObj[id].blindedResearcher || _this.privilegesRootObj[id].unblindedResearcher);

        var participantNowBlinded = p && p.windows && p.windows.dates && p.windows.dates.window_003 && p.windows.dates.window_003.endDateKey && p.windows.dates.window_003.endDateKey < todayKey;

        // Participant must obviously not be a researcher, and then the researcher doing the onboarding must EITHER be blinded (can look at data any time) OR unblinded (in which case they can only look at patient until patient is randomized/blinded)

        var eligible = !isResearcher && (_this.user.privilegesObj.blindedResearcher || _this.user.privilegesObj.unblindedResearcher && !participantNowBlinded);

        return eligible;
      });

      return presenceRootArraySubset.map(function (presenceObj) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, presenceObj, {
          trialId: _this.contactRootObj && _this.contactRootObj[presenceObj.id] && _this.contactRootObj[presenceObj.id].trialId || "-"
        });
      });
    },

    participantMingledAccessibleByResearcher: function participantMingledAccessibleByResearcher() {
      var _this2 = this;

      // You can Monitor Data Entry on a participant who has NOT completed, as long as EITHER you are blinded OR the patient is still in the pre-blinding period.

      var todayKey = new Date().toISOString().slice(0, 10);

      // Initial superset
      var participants = this.participantMingledArray.filter(function (participantMingled) {
        return participantMingled.participant && (participantNotBlindedYet(participantMingled) || _this2.user.privilegesObj.blindedResearcher);
      });

      // Limit to ORBITA trial IDs, if requested
      if (this.onlyShowOrbita2) {
        participants = participants.filter(function (pm) {
          return (pm.trialId || "").includes("ORBITA2");
        });
      }

      // Limit to non-completed patients, if requested
      if (this.onlyShowIncomplete) {
        participants = participants.filter(function (pm) {
          return !pm.participantCompleted;
        });
      }

      return participants;

      // Helper functions follow:

      function participantNotBlindedYet(
      // a helper function that processes a participantMingled. This gets hoisted so it is available in the RETURN statement of the parent function
      p) {
        return p && p.windows && p.windows.dates && p.windows.dates.window_003 && p.windows.dates.window_003.endDateKey && !(p.windows.dates.window_003.endDateKey < todayKey);
      }
    },

    calendarAttrsContactStartDateKey: function calendarAttrsContactStartDateKey(dateKey) {
      return [{
        key: "today",
        highlight: {
          backgroundColor: "#ff8080"
        },
        // Just use a normal style
        contentStyle: {
          color: "#fafafa"
        },
        dates: new Date(dateKey)
      }];
    }
  },

  created: function created() {
    var _this3 = this;

    // CONSTANTS

    this.windowDisplayNames = ["Baseline 1", "Baseline 2", "Baseline wait, i.e. DATE OF PROCEDURE", "Blinded  1", "Blinded  2", "Blinded  3", "Blinded  4", "Blinded  5", "Blinded  6", "Blinded  7", "Blinded  8", "Blinded  9", "Blinded 10", "Blinded 11", "Blinded 12", "Blinded wait to unblinding"];
    this.nWindows = 3 + 13;
    this.window1toN = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(this.nWindows + 1).keys())).slice(1);
    this.windowKeys = this.window1toN.map(function (i) {
      return "window_" + ("000" + i).slice(-3);
    });

    // BOOTUP BINDINGS

    // A good way to get list of PARTICIPANTS is to look at the privileges object because (a) All participants must have a "true" in the participants property, and (b) It doesn't change much so there is little unnecessary reactivity

    __WEBPACK_IMPORTED_MODULE_10__firebaseSetup_js__["h" /* privilegesRootRef */].on("value", function (snapshot) {
      // Do repeatedly on change
      _this3.privilegesRootObj = snapshot.val();
      _this3.updateParticipantMingledArray();
    });

    __WEBPACK_IMPORTED_MODULE_10__firebaseSetup_js__["d" /* contactRootRef */].on("value", function (snapshot) {
      _this3.contactRootObj = snapshot.val();
      _this3.updateParticipantMingledArray();
    });

    __WEBPACK_IMPORTED_MODULE_10__firebaseSetup_js__["g" /* presenceRootRef */].on("value", function (snapshot) {
      _this3.presenceRootObj = snapshot.val();
      _this3.updateParticipantMingledArray();

      // We need this for onboarding, separate from the Joined Participant array because people aren't participants yet so won't be on the participants array
      _this3.presenceRootArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.presenceRootObj).map(function (id) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this3.presenceRootObj[id], {
          id: id
        });
      });
    });

    // This notifies all computers on which the researcher is logged in to react to changes in mode, i.e. to go to the same page so he can easily call them on the phone after selecting their record on the desktop computer.
    __WEBPACK_IMPORTED_MODULE_10__firebaseSetup_js__["g" /* presenceRootRef */].child(this.user.id).child("resView").on("value", function (snapshot) {
      return _this3.researcherAllScreensRespondToChangeInMode(snapshot.val());
    });
  },


  filters: {
    phone: function phone(raw) {
      var bare = raw.replace(/[ -]/g, "");
      if (bare.charAt(0) === "0" && bare.charAt(1) >= 1 && bare.charAt(1) <= 9) {
        if (bare.charAt(1) === "7") {
          return bare.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, "$1 $2 $3 $4");
        } else {
          return bare.replace(/(\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
        }
      }
    }
  },

  methods: {
    windowKeyTo1toN: function windowKeyTo1toN(windowKey) {
      return this.windowKeys.indexOf(windowKey);
    },
    windowKeyToDisplayName: function windowKeyToDisplayName(windowKey) {
      var i = this.windowKeyTo1toN(windowKey);
      if (i >= 0) {
        return this.windowDisplayNames[i];
      } else {
        return "Unknown windowKey: " + windowKey;
      }
    },
    durationBetweenKeys: function durationBetweenKeys(key1, key2) {
      var time1 = new Date(key1).getTime();
      var time2 = new Date(key2).getTime();
      var diffDays = Math.round((time2 - time1) / 86400000);
      return diffDays;
    },
    windowDurationIfAvailable: function windowDurationIfAvailable(windowKey) {
      var startDateKey = this.participant.contactObj.startDateKey;
      var windowNumber = this.windowKeyTo1toN(windowKey);

      if (windowNumber === 0 && startDateKey && this.participant.contactObj && this.participant.contactObj.windows && this.participant.contactObj.windows.dates && this.participant.contactObj.windows.dates[windowKey] && this.participant.contactObj.windows.dates[windowKey].endDateKey) {
        return " (" + (this.durationBetweenKeys(startDateKey, this.participant.contactObj.windows.dates[windowKey].endDateKey) + 1) + "d)";
      }

      if (windowNumber >= 1 && this.participant.contactObj.windows.dates[windowKey]) {
        var thisEndDateKey = this.participant.contactObj.windows.dates[windowKey].endDateKey;
        var previousWindowNumber = windowNumber - 1;
        var previousWindowKey = this.windowKeys[previousWindowNumber]; // e.g. window_005
        if (thisEndDateKey && this.participant.contactObj.windows.dates[previousWindowKey] && this.participant.contactObj.windows.dates[previousWindowKey].endDateKey) {
          var previousEndDateKey = this.participant.contactObj.windows.dates[previousWindowKey].endDateKey;
          return " (" + this.durationBetweenKeys(previousEndDateKey, thisEndDateKey) + "d)";
        } else {
          return "";
        }
      }
    },


    triggerParticipantScreenRefresh: function triggerParticipantScreenRefresh() {
      // DUPLICATED -- naughtily --- in SYMPTOMENTRY
      // this is picked up by the firebase "ON" on the refresh node and triggers this.startSymptomEntryComponentAfresh() at the end of a setTimeout (to let the digest finish)
      this.participant.statusRef.child("refresh").set(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    },

    updateParticipantMingledArray: function updateParticipantMingledArray() {
      var _this4 = this;

      // Produce an array containing all data of PARTICIPANTS (not just newly logged on people) EXCEPT the "STATUS" which is too large to load for all participants at once

      // Step 1. Get list of all participants, using "privileges" since all participants (and staff, but never mind) have an entry here.
      this.participantIdArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.privilegesRootObj).filter(function (id) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          id: id
        }, _this4.privilegesRootObj[id].participant);
      });

      // Step 2. Stick all the various arrays side-to-side into the MingledArray
      this.participantMingledArray = this.participantIdArray.map(function (id) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          id: id
        }, _this4.contactRootObj[id], _this4.privilegesRootObj[id], _this4.presenceRootObj[id], {
          /* extra copy of this at the root of the object, so can be sorted by b-table; where no data inject something that sorts ABOVE all dates */
          completeToDateKey: ((_this4.presenceRootObj[id] || {}).progress || {}).completeToDateKey || "- nil -"
        });
      });

      var todayKey = new Date().toISOString().slice(0, 10);
      this.participantMingledArray.forEach(function (p) {
        var diffMs = new Date(todayKey).getTime() - new Date(p.completeToDateKey).getTime();
        var diffDays = Math.round(diffMs / 86400000);
        if (p.participantCompleted) {
          p._rowVariant = "light";
        } else if (diffDays <= 2) {
          p._rowVariant = "success";
        } else if (diffDays === 3) {
          p._rowVariant = "warning";
        } else {
          p._rowVariant = "danger";
        }
      });
    },


    // ===============================================================

    // To synch all the screens of a researcher together, when he changes mode, what he actually is doing is writing the desired mode to the PRESENCE object and then waiting for this to be bounced back to him (and all of his other logged in screens). This makes it easy to call patient from the research mobile phone if he is logged in there.

    researcherAllScreensRespondToChangeInMode: function researcherAllScreensRespondToChangeInMode(resView) {
      if (!resView) {
        resView = { mode: "home", participantId: null };
      }
      this.mode = resView.mode;
      if (resView.participantId) {
        this.bindParticipantToAUserId(resView.participantId); // Call my parent function that binds "this.participant" to the user id given here.
      }
    },
    oneParticipantOnboardingFromId: function oneParticipantOnboardingFromId(id) {
      this.user.presenceRef.child("resView").update({ mode: "onboardingOne", participantId: id });
    },
    oneParticipantOnboardingFromItem: function oneParticipantOnboardingFromItem(item) {
      this.oneParticipantOnboardingFromId(item.id);
    },
    goHome: function goHome() {
      this.user.presenceRef.child("resView").update({ mode: "home", participantId: null });
    },
    goOnboardingList: function goOnboardingList() {
      this.user.presenceRef.child("resView").update({ mode: "onboardingList", participantId: null });
    },
    goMonitorList: function goMonitorList() {
      this.user.presenceRef.child("resView").update({ mode: "monitorList", participantId: null });
    },
    goExport: function goExport() {
      this.user.presenceRef.child("resView").update({ mode: "export", participantId: null });
    },
    goMonitorOneFromItem: function goMonitorOneFromItem(item) {
      this.user.presenceRef.child("resView").update({ mode: "monitorOne", participantId: item.id });
    },
    goDisplayOneFromItem: function goDisplayOneFromItem(item) {
      this.user.presenceRef.child("resView").update({ mode: "displayOne", participantId: item.id });
    },


    // ===============================================================
    privilegesSummaryString: function privilegesSummaryString(privilegesObj) {
      var summaryList = [];
      if (!privilegesObj) {
        privilegesObj = {};
      }
      if (privilegesObj.participant) {
        summaryList.push("Participant");
      }
      if (privilegesObj.blindedResearcher) {
        summaryList.push("Blinded Researcher");
      }
      if (privilegesObj.unblindedResearcher) {
        summaryList.push("Unblinded Staff");
      }
      if (summaryList.length === 0) {
        summaryList.push("No role yet");
      }

      return summaryList.join(", ");
    },


    convertFromDateObjToDateKey: function convertFromDateObjToDateKey(dateObj) {
      return dateObj.getFullYear() + "-" + (" 0" + (dateObj.getMonth() + 1)).slice(-2) + "-" + ("0" + dateObj.getDate()).slice(-2);
    },

    fillAllWindowsWeekly: function fillAllWindowsWeekly(thisParticipant) {
      var firstWindowKey = this.windowKeys[0];
      if (firstWindowKey) {
        // ... is not undefined
        var date = new Date(thisParticipant.contactObj.startDateKey);
        date.setDate(date.getDate() + 6); // 6 not 7, fencepost!
        var endDateKey = this.convertFromDateObjToDateKey(date);
        thisParticipant.contactRef.child("windows/dates").child(firstWindowKey).child("endDateKey").set(endDateKey);

        // Manually write because reaction may not be in time, to allow the next function to run.
        thisParticipant.contactObj.windows.dates[firstWindowKey].endDateKey = endDateKey;

        // Then call for rest to be filled in
        this.fillDownWeekly(thisParticipant, firstWindowKey);
      }
    },
    fillPrerandomizationWindows: function fillPrerandomizationWindows(thisParticipant) {
      var firstWindowKey = this.windowKeys[0];
      if (firstWindowKey) {
        // ... is not undefined
        var date = new Date(thisParticipant.contactObj.startDateKey);

        date.setDate(date.getDate() + 6); // 6 not 7, fencepost!
        thisParticipant.contactRef.child("windows/dates").child(firstWindowKey).child("endDateKey").set(this.convertFromDateObjToDateKey(date));

        date.setDate(date.getDate() + 7);
        thisParticipant.contactRef.child("windows/dates").child(this.windowKeys[1]).child("endDateKey").set(this.convertFromDateObjToDateKey(date));

        thisParticipant.contactRef.child("windows/dates").child(this.windowKeys[2]).child("endDateKey").set(null);
      }
    },
    fillDownWeekly: function fillDownWeekly(thisParticipant, windowKeyFromWhichToFill) {
      var _this5 = this;

      var currentEndDateKey = null;
      this.windowKeys.forEach(function (windowKey) {
        if (windowKey === windowKeyFromWhichToFill) {
          currentEndDateKey = thisParticipant.contactObj.windows.dates[windowKey].endDateKey;
        } else if (windowKey > windowKeyFromWhichToFill) {
          var date = new Date(currentEndDateKey);

          if (windowKey === _this5.windowKeys[_this5.windowKeys.length - 1]) {
            // Typically we add a week, but for the last window we add a year to make it flexible-width
            // We err massively on the side of long-ness so that the window doesn't end (and the questions get asked) ahead of time.
            currentEndDateKey = null;
          } else {
            date.setDate(date.getDate() + 7);
            currentEndDateKey = _this5.convertFromDateObjToDateKey(date);
          }

          thisParticipant.contactRef.child("windows").child("dates").child(windowKey).child("endDateKey").set(currentEndDateKey);
        }
      });
    }
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBlinded: { type: Boolean, default: false }
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAnginaIs_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f2fc34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAnginaIs_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAnginaIs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f2fc34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAnginaIs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: String
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      default: "Choose"
    },
    fbRef: {
      // For writing
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      boundVariable: "",

      options: ["walk indoors on level ground", "walk outdoors on level ground", "walk up a hill without stopping", "walk up one flight of stairs without stopping", "walk up 2 flights of stairs without stopping", "do gardening", "do light housework", "run or jog", "lift or move heavy objects", "cycle", "play football", "walk briskly for 10 minutes", "have a stressful situation"]
    };
  },
  created: function created() {
    var _this = this;

    this.fbRef.on("value", function (snapshot) {
      _this.boundVariable = snapshot.val();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.fbRef.off("value");
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_trialConfig_mjs__ = __webpack_require__(491);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//        _
//  |\ | |_) |\/|   o ._   _ _|_  _. | |
//  | \| |   |  |   | | | _>  |_ (_| | |
//  Needs:
//    npm install file-saver
//    npm install jszip



var JSZip = __webpack_require__(492);

//   _   _      _
//  | | | | ___| |_ __   ___ _ __ ___
//  | |_| |/ _ \ | '_ \ / _ \ '__/ __|
//  |  _  |  __/ | |_) |  __/ |  \__ \
//  |_| |_|\___|_| .__/ \___|_|  |___/
//               |_|

function clean(value) {
  return value.replace(/,/g, "{comma}").replace(/"/g, "{quotes}");
}
function makeLine(arrayOfValues) {
  return arrayOfValues.map(String).map(clean).join(",") + "\n";
}
function symptomIdFromI0(i0) {
  return "symptom_" + String(1 + i0).padStart(3, "0");
}
function durationBetweenKeys(key1, key2) {
  var time1 = new Date(key1).getTime();
  var time2 = new Date(key2).getTime();
  var diffDays = Math.round((time2 - time1) / 86400000);
  return diffDays;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DataExport",
  props: {
    participantIdArray: {
      type: Array,
      required: true
    },
    contactRootObj: {
      type: Object,
      required: true
    },
    statusRootRef: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      state: null,
      trialContactsCsv: "",
      trialDailyCsv: "",
      trialWeeklyYesNoCsv: ""
    };
  },


  methods: {
    onExport: function onExport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ACTIVITY_KEYS, MAX_N_SYMPTOMS, POTENTIAL_SYMPTOM_IDS, participantIds, participantPromises;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.state = "working";
                ACTIVITY_KEYS = ["activity_001", "activity_002"];
                MAX_N_SYMPTOMS = 1;
                POTENTIAL_SYMPTOM_IDS = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(Array(MAX_N_SYMPTOMS).keys())).map(symptomIdFromI0);
                participantIds = _this.participantIdArray;

                //   _____                 _                       _               _
                //  | ____|_ __ ___  _ __ | |_ _   _    ___  _   _| |_ _ __  _   _| |_ ___
                //  |  _| | '_ ` _ \| '_ \| __| | | |  / _ \| | | | __| '_ \| | | | __/ __|
                //  | |___| | | | | | |_) | |_| |_| | | (_) | |_| | |_| |_) | |_| | |_\__ \
                //  |_____|_| |_| |_| .__/ \__|\__, |  \___/ \__,_|\__| .__/ \__,_|\__|___/
                //                  |_|        |___/                  |_|

                _this.trialContactsCsv = "Participant Id,Start date ISO," + ACTIVITY_KEYS.join(",") + ",Number of symptoms," + POTENTIAL_SYMPTOM_IDS.join(",") + "\n";

                _this.trialDailyCsv = "Participant Id,Days since start,Date ISO,Symptom YesNo,Symptom frequency,Symptom severity 1-600\n";
                _this.trialWeeklyYesNoCsv = "Participant Id,Window Id,End date ISO,End relative,Activity Id,Symptom YesNo\n";

                //   _                                                    _
                //  | |    ___   ___  _ __     _____   _____ _ __   _ __ | |_ ___
                //  | |   / _ \ / _ \| '_ \   / _ \ \ / / _ \ '__| | '_ \| __/ __|
                //  | |__| (_) | (_) | |_) | | (_) \ V /  __/ |    | |_) | |_\__ \
                //  |_____\___/ \___/| .__/   \___/ \_/ \___|_|    | .__/ \__|___/
                //                   |_|                           |_|
                participantPromises = participantIds.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(participantId) {
                    var contact, statusLive, days, windows, windowKeys, nSymptoms, trialId, startDateKey, activityStrings, symptomStringsOrDash, contactsLine, dateKeys;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            //    ____      _     _               _         __            _
                            //   / ___| ___| |_  | |__   __ _ ___(_) ___   / _| ___  __ _| |_ ___
                            //  | |  _ / _ \ __| | '_ \ / _` / __| |/ __| | |_ / _ \/ _` | __/ __|
                            //  | |_| |  __/ |_  | |_) | (_| \__ \ | (__  |  _|  __/ (_| | |_\__ \
                            //   \____|\___|\__| |_.__/ \__,_|___/_|\___| |_|  \___|\__,_|\__|___/

                            // Get raw data
                            contact = _this.contactRootObj[participantId] || {};
                            _context.next = 3;
                            return _this.statusRootRef.child(participantId).child("live").once("value");

                          case 3:
                            statusLive = _context.sent.val();


                            // Analyse
                            days = (statusLive || {}).days || {};
                            windows = (statusLive || {}).windows || {};
                            windowKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(windows);
                            nSymptoms = 1;

                            //
                            //  \    / ._ o _|_  _     _  _  ._ _|_  _.  _ _|_
                            //   \/\/  |  |  |_ (/_   (_ (_) | | |_ (_| (_  |_

                            trialId = contact.trialId || "No trial Id for " + participantId;
                            startDateKey = contact.startDateKey;

                            // Each patient has THE SAME number of activities

                            activityStrings = ACTIVITY_KEYS.map(function (activityKey) {
                              return (((contact || {}).windows || {}).questions || {})[activityKey] || "missing activity description";
                            });

                            // // Each patient has a VARIABLE number of symptoms

                            symptomStringsOrDash = POTENTIAL_SYMPTOM_IDS.map(function (_) {
                              return "-";
                            });

                            symptomStringsOrDash[0] = contact.myAnginaIs;

                            contactsLine = makeLine([trialId, startDateKey].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(activityStrings), [nSymptoms], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(symptomStringsOrDash)));

                            _this.trialContactsCsv += contactsLine;

                            //
                            //   \    / ._ o _|_  _     _|  _. o |
                            //    \/\/  |  |  |_ (/_   (_| (_| | | \/
                            //                                     /
                            dateKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(days);

                            dateKeys.forEach(function (dateKey) {
                              // symptomIds.forEach((symptomId) => {
                              var day = (days || {})[dateKey];
                              if (day) {
                                var iDay = durationBetweenKeys(startDateKey, dateKey);
                                var dayLine = makeLine([trialId, iDay, dateKey, (day || {}).anginaYesNo || "missing data", (day || {}).anginaCount || 0, (day || {}).anginaSeverity || 0]);
                                _this.trialDailyCsv += dayLine;
                              }
                              // });
                            });

                            //
                            //  \    / ._ o _|_  _         o ._   _|  _        _
                            //   \/\/  |  |  |_ (/_   \/\/ | | | (_| (_) \/\/ _>
                            // which has (a) Yes/No BY SYMPTOM & BY ACTIVITY
                            // and (b) Restriction & severity, just once per window

                            windowKeys.forEach(function (windowKey) {
                              var windowEndDateKey = ((((contact || {}).windows || {}).dates || {})[windowKey] || {}).endDateKey;
                              var iEndDate = durationBetweenKeys(startDateKey, windowEndDateKey);
                              var windowData = (windows || {})[windowKey];
                              if (windowData) {
                                // SymptomYesNo
                                ACTIVITY_KEYS.forEach(function (activityKey) {
                                  var activity = ((windowData || {}).questions || {})[// eslint-disable-line standard/computed-property-even-spacing
                                  activityKey];
                                  // symptomIds.forEach((symptomId) => {
                                  var activityLine = makeLine([trialId, windowKey, windowEndDateKey, iEndDate, activityKey,
                                  // symptomId,
                                  (activity || {}).anginaYesNo || "no data"]);
                                  _this.trialWeeklyYesNoCsv += activityLine;
                                });
                                // });
                              }
                            });

                          case 18:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(participantPromises);

              case 11:

                setTimeout(function () {
                  // Just so people realise something seriously worthwhile is happening
                  _this.state = "ready";
                }, 5000);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    downloadAllFilesAsZip: function downloadAllFilesAsZip() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var zip, content, zipFileName;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // https://muhimasri.com/blogs/how-to-save-files-in-javascript/

                zip = new JSZip();

                zip.file("Participants.csv", _this2.trialContactsCsv);
                zip.file("Daily.csv", _this2.trialDailyCsv);
                zip.file("Weekly.csv", _this2.trialWeeklyYesNoCsv);
                _context3.next = 6;
                return zip.generateAsync({ type: "blob" });

              case 6:
                content = _context3.sent;
                zipFileName = __WEBPACK_IMPORTED_MODULE_6__components_trialConfig_mjs__["a" /* trialName */] + " data " + new Date().toISOString().slice(0, 10) + ".zip";

                Object(__WEBPACK_IMPORTED_MODULE_5_file_saver__["saveAs"])(content, zipFileName);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_st_elsewhere_BuildVersion_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyAnginaIs_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilGetNewest_js__ = __webpack_require__(315);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // This is overwritten by the building process

 // but remember to also re-export it in methods
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MyAnginaIs: __WEBPACK_IMPORTED_MODULE_1__MyAnginaIs_vue__["a" /* default */]
  },

  props: {
    myAnginaIs: String, // is from participant.contactObj.myAnginaIs
    windowsQuestions: {
      // is from participant.contactObj.windows.questions
      activity_001: String,
      activity_002: String
    },
    userId: String,
    privileges: {}
  },

  data: function data() {
    return {
      buildVersion: __WEBPACK_IMPORTED_MODULE_0__from_st_elsewhere_BuildVersion_js__["a" /* BUILDVERSION */], // A constant written to buildVersion.js by the build command
      doc: document
    };
  },

  methods: {
    getNewest: __WEBPACK_IMPORTED_MODULE_2__utilGetNewest_js__["a" /* getNewest */], // It was imported into the global area, and then I have to re-export it here so the HTML Template can see it. Basically I create a this.getNewest which is identical to the global getNewest
    scrollHelpIntoView: function scrollHelpIntoView() {
      setTimeout(function () {
        return document.getElementById("scrollTarget").scrollIntoView({ behaviour: "smooth" });
      }, 500);
    }
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defer_js__ = __webpack_require__(504);
//
//
//
//
//
//
//
//
//
//
//
//

// https://github.com/Wyntau/vue-ios-actionsheet


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    buttons: [Array]
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  methods: {
    activate: function activate() {
      this._deferred = Object(__WEBPACK_IMPORTED_MODULE_0__defer_js__["a" /* default */])();
      this.showModal = true;
      return this._deferred.promise;
    },
    deactivate: function deactivate() {
      this.showModal = false;
      this._deferred.reject();
    },
    onClick: function onClick(button, selectedIndex, selectedGroupIndex) {
      if (button.disable || button.label) {
        return;
      }
      if (button.handle) {
        button.handle({ button: button, selectedIndex: selectedIndex, selectedGroupIndex: selectedGroupIndex });
      }
      this._deferred.resolve({ button: button, selectedIndex: selectedIndex, selectedGroupIndex: selectedGroupIndex });
      this.showModal = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  computed: {
    groups: function groups() {
      if (!this.buttons) {
        return [];
      }
      return this.buttons.map(function (group) {
        if (Object.prototype.toString.call(group) === "[object Object]") {
          return [group];
        } else {
          return group;
        }
      });
    }
  }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebaseSetup_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_calendar__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_calendar_lib_v_calendar_min_css__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_calendar_lib_v_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_calendar_lib_v_calendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__ = __webpack_require__(508);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// UI


// Data
 // this is my local file with my personal API key etc
 // #### I THINK WE ARE NOT USING THIS?


// v-calendar



// App's actual components


// font-awesome. Three imports, a library.add, and a Vue.use of two things From https://fontawesome.com/how-to-use/on-the-web/using-with/vuejs



__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["b" /* faHandshake */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["e" /* faPeopleCarry */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["a" /* faChevronCircleLeft */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["c" /* faHome */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["d" /* faList */], __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["f" /* faPhone */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("font-awesome-icon", __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

/* eslint-disable no-new */
// Vue.use(VueRouter);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* BootstrapVue */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_calendar___default.a, { firstDayOfWeek: 2 });

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  template: "<App></App>",
  components: { App: __WEBPACK_IMPORTED_MODULE_8__components_App_vue__["a" /* default */] }
});

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f9991d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(506);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f9991d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.runningVersionRelative > 0)?_c('b-alert',{attrs:{"show":""}},[_c('h4',[_vm._v("Release-candidate version now running")])]):_vm._e(),_vm._v(" "),(_vm.runningVersionRelative < 0)?_c('b-alert',{staticClass:"m-2",attrs:{"show":""}},[_c('h3',[_vm._v("New version available")]),_vm._v(" "),(_vm.canUpdateNow)?_c('div',[_c('h5',[_vm._v("\n        There is a new version of this App. The App will shortly update\n        itself, and this message will disappear.\n      ")])]):_c('div',[_c('h5',[_vm._v("\n        Relax. Complete your data entry. Until then, this App will wait\n        patiently.\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("\n        Message still here, even after you've finished?\n        "),_c('b-button',{attrs:{"variant":"outline-dark","size":"sm"},on:{"click":_vm.getNewest}},[_vm._v("Update now")])],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppOfflineWarning_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f8e2cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppOfflineWarning_vue__ = __webpack_require__(425);
function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35f8e2cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppOfflineWarning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f8e2cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppOfflineWarning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slow-to-anger"}},[_c('div',{staticClass:"alert alert-danger",staticStyle:{"overflow":"hidden","margin":"0.5em"}},[_c('h3',[_vm._v("Internet connection?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Currently cannot reach the internet.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logged-in"},[_vm._m(0),_vm._v(" "),_c('div',[(_vm.name)?_c('div',[_vm._v(_vm._s(_vm.name))]):(_vm.email)?_c('div',[_vm._v(_vm._s(_vm.email))]):_vm._e(),_vm._v(" "),(_vm.trialId)?_c('div',[_vm._v(_vm._s(_vm.trialId))]):_vm._e(),_vm._v(" "),(_vm.privileges && _vm.privileges.blindedResearcher)?_c('div',{staticClass:"little"},[_vm._v("Blinded Staff")]):_vm._e(),_vm._v(" "),(_vm.privileges && _vm.privileges.unblindedResearcher)?_c('div',{staticClass:"little"},[_vm._v("Unblinded Staff")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"max-width":"5em","max-height":"100%"},attrs:{"src":__webpack_require__(158),"alt":"Orbita-2 Logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPrivacy_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff9598c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPrivacy_vue__ = __webpack_require__(430);
function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPrivacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff9598c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPrivacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticStyle:{"padding":"0.5em","margin":"0.5em"},attrs:{"show":"","variant":"primary"}},[_c('h3',[_vm._v("Welcome "+_vm._s(_vm.displayName)+"!")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.participantSufficientInfo.privilegesParticipant && !_vm.participantSufficientInfo.statusPrivacy)?_c('div',[_c('p',[_vm._v("We are the ORBITA-2 researchers, based at Imperial College London, United Kingdom. We need your permission to store information about you.\n    ")]),_vm._v(" "),_c('h5',[_vm._v("What we store and why")]),_vm._v(" "),_c('p',[_vm._v("Your name, email and phone numbers, so we can contact you and you can log in."),_c('br'),_vm._v("\n      Your symptom answers, to analyse for the trial.")]),_vm._v(" "),_c('h5',[_vm._v("How long for?")]),_vm._v(" "),_c('p',[_vm._v("Your name and contact details will be deleted when you finish the trial, or earlier if you ask. After that, our system will keep only your anonymous symptom answers. Symptom answers from all participants will be the main result of the ORBITA-2 trial, which will be published to help treat future patients with angina."),_c('br'),_vm._v("Later, we may make the anonymous symptom answers publicly available so that researchers around the world can check our findings and build upon them.\n    ")]),_vm._v(" "),_c('h5',[_vm._v("Your rights")]),_vm._v(" "),_c('p',[_vm._v("You have a right to a copy of your data, and a right to have it deleted from our system. You can exercise these rights by contacting our administrator Juliet Holmes on 0207 594 5735.")]),_vm._v(" "),_c('h5',[_vm._v("We need your permission")]),_vm._v(" "),_c('p',[_vm._v(" Do you allow us to store and process your information as described above?")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-evenly"}},[_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){return _vm.$emit('gave-permission');}}},[_vm._v("    Yes    ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","variant":"danger"},on:{"click":function($event){return _vm.$emit('refused-permission')}}},[_vm._v("    No    ")])],1),_vm._v(" "),_c('br')]):_c('div',[_c('h4',[_vm._v("Now the researcher will finish setting up your details:")]),_vm._v(" "),_c('ul',[(!_vm.participantSufficientInfo.privilegesParticipant)?_c('li',[_vm._v(" That you are joining the trial")]):_vm._e(),_vm._v(" "),(!_vm.participantSufficientInfo.contactShortName)?_c('li',[_vm._v(" Short name or nickname")]):_vm._e(),_vm._v(" "),(!_vm.participantSufficientInfo.contactStartDateKey)?_c('li',[_vm._v(" Starting date")]):_vm._e(),_vm._v(" "),(!_vm.participantSufficientInfo.contactMyAnginaIs)?_c('li',[_vm._v(" Your own description of your angina")]):_vm._e(),_vm._v(" "),(!_vm.participantSufficientInfo.contactWindowQuestions)?_c('li',[_vm._v(" Activities causing angina")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAwaitingApproval_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b19e5c84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAwaitingApproval_vue__ = __webpack_require__(433);
function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAwaitingApproval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b19e5c84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAwaitingApproval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticStyle:{"padding":"0.5em","margin":"0.5em"},attrs:{"show":"","variant":"primary"}},[_c('h3',[_vm._v("Thank you")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("You have successfully logged in to the symptom reporting system.\n\n    "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    We're waiting for the researcher to link you to ORBITA-2.\n    "),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPracticeWrongAnswer_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ad9090_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPracticeWrongAnswer_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPracticeWrongAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ad9090_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPracticeWrongAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{staticClass:"alert alert-danger"},[_c('h2',[_vm._v("Not quite right")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Check Bob's story above, and then try again.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trinity-rings-spinner"},[_c('div',{staticClass:"circle"}),_vm._v(" "),_c('div',{staticClass:"circle"}),_vm._v(" "),_c('div',{staticClass:"circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.participant.statusIsLoaded)?_c('div',{staticClass:"mx-3"},[_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":true}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.entryMode === 'practice')?_c('div',[(_vm.date.targetKey === _vm.date.dayBeforeYesterdayKey)?_c('div',[_c('div',{staticClass:"alert alert-primary",staticStyle:{"margin-bottom":"0"}},[_c('h3',[_vm._v("Welcome to the ORBITA-2 symptom app")]),_vm._v(" "),_c('h4',[_vm._v("\n            To practice, imagine there is a patient called Bob. Read Bob’s\n            story and answer below as if you were Bob.\n          ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("\n            The day before yesterday, Bob had angina\n            "),_c('strong',[_vm._v("twice")]),_vm._v(": once "),_c('strong',[_vm._v("mild")]),_vm._v(" and once\n            "),_c('strong',[_vm._v("moderate")]),_vm._v(".\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.date.targetKey === _vm.date.yesterdayKey)?_c('div',[_c('div',{staticClass:"alert alert-primary",staticStyle:{"margin-bottom":"0"}},[_c('h3',[_vm._v("Practice, Part 2")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_c('strong',[_vm._v("Yesterday,")]),_vm._v(" Bob had no angina. "),_c('br'),_vm._v("Answer for\n            Bob below.\n          ")])])]):_vm._e(),_vm._v(" "),(
          _vm.symptomEntryProgress.upToDate.days &&
          !_vm.symptomEntryProgress.upToDate.windows
        )?_c('div',[_c('div',{staticClass:"alert alert-primary",staticStyle:{"margin-bottom":"0"}},[_c('h3',[_vm._v("Practice, Part 3")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("\n            Bob says, “In the last couple of days, I've noticed I get angina\n            when I\n            "),_c('strong',[_vm._v(_vm._s(_vm.participant.contactObj.windows.questions.activity_002))]),_vm._v(", but not when I\n            "),_c('strong',[_vm._v(_vm._s(_vm.participant.contactObj.windows.questions.activity_001))]),_vm._v(". ”\n          ")])])]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.symptomEntryProgress.theresMore)?_c('div',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center"}},[_c('SpinnerTrinity')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_c('div',[(_vm.symptomEntryProgress.upToDate.all)?_c('div',[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('h2',[_vm._v("Thank you!")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.entryMode === 'practice')?_c('h4',[_vm._v("\n              Bob is up to date. His next entry would be tomorrow.\n            ")]):_c('h4',[_vm._v("\n              You are up to date. Your next entry will be tomorrow.\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.entryMode !== 'practice')?_c('h4',[_vm._v("\n              Once a week you will also be asked whether you get angina when\n              you\n              "+_vm._s(_vm.participant.contactObj.windows.questions.activity_001 ||
                "** SOME IMPORTANT INFORMATION IS MISSING. PLEASE CONTACT THE ORBITA TEAM AND ASK THEM TO 'SET UP YOUR WEEKLY ACTIVITY DESCRIPTION' **")+", and when you\n              "+_vm._s(_vm.participant.contactObj.windows.questions.activity_002 ||
                "** SOME IMPORTANT INFORMATION IS MISSING. PLEASE CONTACT THE ORBITA TEAM AND ASK THEM TO 'SET UP YOUR WEEKLY ACTIVITY DESCRIPTION' **")+".\n            ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.entryMode === 'live')?_c('p',[_vm._v("\n              All data are saved. App can be closed.\n            ")]):_vm._e()])])]),_vm._v(" "),(_vm.entryMode === 'practice')?_c('div',[_c('div',{staticClass:"alert alert-primary",staticStyle:{"margin-bottom":"0"}},[_c('h4',[_vm._v("Well done!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("\n            You have succeeded in the practice. From now on, use this App\n            daily to report\n            "),_c('em',[_vm._v("your own")]),_vm._v(" angina from\n            "),_c('em',[_vm._v("the day before")]),_vm._v("\n            . \"Angina\" means the symptom that made you go to your doctor: \""+_vm._s(_vm.participant.contactObj.myAnginaIs)+"\". There will be a Help button to remind you of this.\n          ")]),_vm._v(" "),_c('h5',[_vm._v("Ready to use the App?")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-evenly"}},[_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){_vm.writeAndLog(
                  _vm.participant.statusRef.child('trained'),
                  true,
                  true
                )}}},[_vm._v("Yes")]),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","variant":"secondary"},on:{"click":function($event){_vm.writeAndLog(
                  _vm.participant.statusRef.child(_vm.liveOrPractice),
                  null
                );
                _vm.startSymptomEntryComponentAfresh();}}},[_vm._v("\n              No, practice again\n            ")])],1)])]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.symptomEntryProgress.upToDate.all)?_c('div',{staticClass:"progress-container",attrs:{"id":"questions-block"}},[(!_vm.symptomEntryProgress.upToDate.days)?_c('div',{attrs:{"id":"questions-block-for-day"}},[_c('h2',[_vm._v(_vm._s(_vm.date.targetDisplayStringWithComment))]),_vm._v(" "),(
            !_vm.participant.statusObj[_vm.liveOrPractice] ||
            !_vm.participant.statusObj[_vm.liveOrPractice].days ||
            !_vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey] ||
            !_vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey].saved
          )?_c('div',[_c('hr'),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(
                !(
                  _vm.participant.statusObj[_vm.liveOrPractice] &&
                  _vm.participant.statusObj[_vm.liveOrPractice].days &&
                  _vm.participant.statusObj[_vm.liveOrPractice].days[
                    _vm.date.targetKey
                  ] &&
                  _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                    .anginaYesNo
                )
              )?_c('div',[_c('h2',[_vm._v("\n                Did "+_vm._s(_vm.entryMode === "practice" ? "Bob" : "you")+" have any\n                angina?\n              ")]),_vm._v(" "),(_vm.errorWrongPracticeAnswer)?_c('ErrorPracticeWrongAnswer'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-evenly"}},[_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){return _vm.checkAndWriteAnswerToDailyAnginaYesNoQuestion('Yes')}}},[_vm._v("    Yes    ")]),_vm._v(" \n                "),_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){return _vm.checkAndWriteAnswerToDailyAnginaYesNoQuestion(
                      'No' /* includes built-in writing to '.saved', and the TRUE option to recalc */
                    )}}},[_vm._v("    No    ")])],1),_vm._v(" "),_c('br')],1):_vm._e()]),_vm._v(" "),(
              _vm.participant.statusObj[_vm.liveOrPractice] &&
              _vm.participant.statusObj[_vm.liveOrPractice].days &&
              _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey] &&
              _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                .anginaYesNo === 'No'
            )?_c('div',[_c('h5',[_vm._v("\n              No angina  \n              "),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":" button"},on:{"click":function($event){_vm.writeAndLog(
                    _vm.participant.statusRef
                      .child(_vm.liveOrPractice)
                      .child('days')
                      .child(_vm.date.targetKey)
                      .child('anginaYesNo'),
                    null
                  )}}},[_vm._v("\n                Edit\n              ")])])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(
                _vm.participant.statusObj[_vm.liveOrPractice] &&
                _vm.participant.statusObj[_vm.liveOrPractice].days &&
                _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey] &&
                _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                  .anginaYesNo === 'Yes'
              )?_c('div',[(
                  !_vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                    .anginaCount
                )?_c('h5',[_vm._v("\n                Angina  \n                "),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.writeAndLog(
                      _vm.participant.statusRef
                        .child(_vm.liveOrPractice)
                        .child('days')
                        .child(_vm.date.targetKey)
                        .child('anginaYesNo'),
                      null
                    )}}},[_vm._v("\n                  Edit\n                ")])]):_vm._e(),_vm._v(" "),(
                  _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                    .anginaCount
                )?_c('h5',[_vm._v("\n                "+_vm._s(_vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                    .anginaCount)+"\n                episode"+_vm._s(parseInt(
                    _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                      .anginaCount
                  ) >= 2
                    ? "s"
                    : "")+"\n                of angina\n                "),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.writeAndLog(
                      _vm.participant.statusRef
                        .child(_vm.liveOrPractice)
                        .child('days')
                        .child(_vm.date.targetKey)
                        .child('anginaYesNo'),
                      null
                    );
                    _vm.writeAndLog(
                      _vm.participant.statusRef
                        .child(_vm.liveOrPractice)
                        .child('days')
                        .child(_vm.date.targetKey)
                        .child('anginaCount'),
                      null
                    );}}},[_vm._v("\n                  Edit\n                ")])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(
                    _vm.participant.statusObj[_vm.liveOrPractice] &&
                    _vm.participant.statusObj[_vm.liveOrPractice].days &&
                    _vm.participant.statusObj[_vm.liveOrPractice].days[
                      _vm.date.targetKey
                    ] &&
                    _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                      .anginaCount === undefined
                  )?_c('div',[_c('br'),_vm._v(" "),_c('h2',[_vm._v("\n                    How many times did\n                    "+_vm._s(_vm.entryMode === "practice" ? "Bob" : "you")+" have\n                    angina?\n                  ")]),_vm._v(" "),(_vm.errorWrongPracticeAnswer)?_c('ErrorPracticeWrongAnswer'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"max-width":"80vw","display":"flex","flex-direction":"row","flex-wrap":"wrap","padding":"1em"}},[_c('button',{staticClass:"btn btn-primary spaced-button",attrs:{"type":"button"},on:{"click":function($event){_vm.checkAndWriteAnswerToFrequencyQuestion(1);
                        _vm.resetSlider();}}},[_vm._v("\n                      Once\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary spaced-button",attrs:{"type":"button"},on:{"click":function($event){_vm.checkAndWriteAnswerToFrequencyQuestion(2);
                        _vm.resetSlider();}}},[_vm._v("\n                      Twice\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary spaced-button",attrs:{"type":"button"},on:{"click":function($event){_vm.checkAndWriteAnswerToFrequencyQuestion(3);
                        _vm.resetSlider();}}},[_vm._v("\n                      3 times\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary spaced-button",attrs:{"type":"button"},on:{"click":function($event){_vm.checkAndWriteAnswerToFrequencyQuestion(4);
                        _vm.resetSlider();}}},[_vm._v("\n                      4 times\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary spaced-button",attrs:{"type":"button"},on:{"click":function($event){_vm.checkAndWriteAnswerToFrequencyQuestion(5);
                        _vm.resetSlider();}}},[_vm._v("\n                      5 times\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary spaced-button",attrs:{"type":"button"},on:{"click":function($event){_vm.checkAndWriteAnswerToFrequencyQuestion('6 or more');
                        _vm.resetSlider();}}},[_vm._v("\n                      6 or more\n                    ")])])],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(
                    _vm.participant.statusObj[_vm.liveOrPractice] &&
                    _vm.participant.statusObj[_vm.liveOrPractice].days &&
                    _vm.participant.statusObj[_vm.liveOrPractice].days[
                      _vm.date.targetKey
                    ] &&
                    _vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey]
                      .anginaCount !== undefined &&
                    !_vm.validAnginaSeverity(
                      _vm.participant.statusObj[_vm.liveOrPractice].days[
                        _vm.date.targetKey
                      ].anginaSeverity
                    )
                  )?_c('div',{staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("\n                    How bad was\n                    "),(
                        parseInt(
                          _vm.participant.statusObj[_vm.liveOrPractice].days[
                            _vm.date.targetKey
                          ].anginaCount
                        ) >= 2
                      )?_c('span',[_vm._v("\n                      the worst episode\n                    ")]):_c('span',[_vm._v("it")]),_vm._v("?          \n                           \n                  ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[(_vm.errorWrongPracticeAnswer)?_c('ErrorPracticeWrongAnswer'):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","text-align":"center","margin-left":"16px","margin-right":"16px","font-size":"71%"}},[_c('div',{staticStyle:{"width":"33.333%","overflow":"hidden","background-color":"#e5eff7"}},[_vm._v("\n                          Mild\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"33.333%","overflow":"hidden","background-color":"#ccdff0"}},[_vm._v("\n                          Moderate\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"33.333%","overflow":"hidden","background-color":"#b2cfe9"}},[_vm._v("\n                          Severe\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row",staticStyle:{"margin-left":"12px","margin-right":"12px"}},[_c('div',{style:(("width:" + _vm.rangeLeftPc + "%; height:1em;"))}),_vm._v(" "),(_vm.sliderValue >= 1)?_c('div',{staticClass:"zero-width-arrow-up"}):_vm._e(),_vm._v(" "),_c('div',{style:(("width:" + _vm.rangeRightPc + "%; height:1em;"))})]),_vm._v(" "),_c('div',[_c('b-form-input',{attrs:{"type":"range","min":1,"max":600},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('b-button',{style:({
                        background: '#005eb9',
                        opacity: _vm.validAnginaSeverity(_vm.sliderValue) ? 1 : 0,
                      }),attrs:{"size":"lg"},on:{"click":function($event){return _vm.checkAndWriteAnswerToSeverityQuestion(_vm.sliderValue)}}},[_vm._v("    OK    ")])],1)]):_vm._e()])],1):_vm._e()])],1):_vm._e()]):_vm._e(),_vm._v(" "),(
          _vm.symptomEntryProgress.upToDate.days &&
          !_vm.symptomEntryProgress.upToDate.windows
        )?_c('div',{attrs:{"id":"questions-block-for-windows"}},[_c('h2',[_vm._v("\n          During the "+_vm._s((_vm.missingWindow || {}).durationDaysInclusive)+" days\n          from "+_vm._s((_vm.missingWindow || {}).startDateDisplay)+" to\n          "+_vm._s((_vm.missingWindow || {}).endDateDisplay)+":\n        ")]),_vm._v(" "),(
            !_vm.participant.statusObj[_vm.liveOrPractice] ||
            !_vm.participant.statusObj[_vm.liveOrPractice].days ||
            !_vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey] ||
            !_vm.participant.statusObj[_vm.liveOrPractice].days[_vm.date.targetKey].saved
          )?_c('div',[_c('hr'),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',[_c('h3',[_vm._v("\n                "+_vm._s(_vm.entryMode === "practice"
                    ? "We need to know from Bob, “When you"
                    : "When you")+"\n                "),_c('strong',[_vm._v("\n                  "+_vm._s(_vm.missingWindow &&
                    _vm.missingWindow.question &&
                    _vm.missingWindow.question.whenYou)+"\n                ")]),_vm._v("\n                , do you get angina?"+_vm._s(_vm.entryMode === "practice" ? "”" : "")+"\n              ")]),_vm._v(" "),(_vm.errorWrongPracticeAnswer)?_c('ErrorPracticeWrongAnswer'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-evenly"}},[_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){return _vm.checkAndWriteAnswerToWindowQuestion('Yes')}}},[_vm._v("    Yes    ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){return _vm.checkAndWriteAnswerToWindowQuestion('No')}}},[_vm._v("    No    ")])],1)],1)])],1):_vm._e()]):_vm._e()]):_vm._e()])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResView_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6777b728_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResView_vue__ = __webpack_require__(498);
function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6777b728_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResViewNewParticipantHelp_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7735ab13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResViewNewParticipantHelp_vue__ = __webpack_require__(478);
function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResViewNewParticipantHelp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7735ab13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResViewNewParticipantHelp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":"","variant":"primary"}},[_c('h5',[_vm._v("1. On "),_c('strong',[_vm._v("their")]),_vm._v(" phone, get ORBITA-2 app:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" Open Safari for iPhone or Chrome for Android, or either for laptop.")]),_vm._v(" "),_c('li',[_vm._v(" Go to "),_c('strong',[_vm._v("hq.orbita2.com")])]),_vm._v(" "),_c('li',[_vm._v("\"Add to Home Screen\" as follows:")]),_vm._v(" "),_c('ul',[_c('li',[_c('em',[_vm._v("Safari")]),_vm._v("   Square-box-up-arrow at bottom, scroll 2nd row.\n      ")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("Chrome")]),_vm._v("   Triple dot at top right.\n      ")])]),_vm._v(" "),_c('li',[_vm._v(" Close Safari or Chrome")])]),_vm._v(" "),_c('h5',[_vm._v("2. Open ORBITA-2 app icon and: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Patient enters email address (or family member's or create new gmail)\n    ")]),_vm._v(" "),_c('li',[_vm._v(" Sets a password (at least 6 chars)\n    ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You")]),_vm._v(" scroll down to Staff Only section, press \"Create New Participant\"."),_c('br')]),_vm._v(" "),_c('li',[_vm._v("Say \"Yes\" to storing password (saves them grief later).")])]),_vm._v(" "),_c('h5',[_vm._v("3. Tell ORBITA-2 system their details")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Below this \"help\" message, click the patient's email, typically near the top.\n    ")]),_vm._v(" "),_c('li',[_vm._v("Activate them as a participant.")]),_vm._v(" "),_c('li',[_vm._v("\n      They read privacy policy while you complete setup.\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      Then help them through the practice on Bob.\n    ")])]),_vm._v(" "),_c('h5',[_vm._v("Unblinded staff only have access until the date of randomization")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("So don't enter the date of randomization until it happens.\n    ")]),_vm._v(" "),_c('li',[_vm._v("If you accidentally enter an incorrectly early randomization date, and therefore lose access, ask a Blinded Researcher to correct the randomization date.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":"","variant":"secondary"}},[_c('h4',[_vm._v("When you joined ORBITA-2, you told us:")]),_vm._v(" "),_c('h4',[_vm._v("My angina is "),_c('strong',[_vm._v(_vm._s(_vm.text || "** INFORMATION MISSING ** Please call the ORBITA HQ helpline and tell them that your angina description has not yet been set up"))]),_vm._v(".")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResViewAnginaTrigger_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_732a3256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResViewAnginaTrigger_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResViewAnginaTrigger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_732a3256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResViewAnginaTrigger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',[_c('b-dropdown',{staticStyle:{"width":"100%"},attrs:{"text":_vm.text,"variant":"light"}},[_vm._l((_vm.options),function(option,index){return _c('b-dropdown-item-button',{key:index,on:{"click":function($event){_vm.boundVariable=option; _vm.fbRef.set(_vm.boundVariable.trim());}}},[_vm._v("\n        "+_vm._s(option)+"\n      ")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"diabled":""}},[_vm._v("Or type into box")])],2)],1),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"when you","append":"."}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"e.g. walk to your local post office"},on:{"change":function($event){_vm.fbRef.set(_vm.boundVariable.trim());}},model:{value:(_vm.boundVariable),callback:function ($$v) {_vm.boundVariable=$$v},expression:"boundVariable"}})],1),_vm._v(" "),(_vm.boundVariable && _vm.boundVariable.charAt(0).toLowerCase() !== _vm.boundVariable.charAt(0))?_c('b-alert',{staticClass:"mt-2",attrs:{"show":"","variant":"danger"}},[_vm._v("Please don't capitalise as it messes up questions later shown to the participant.")]):_vm._e(),_vm._v(" "),(_vm.boundVariable && _vm.boundVariable.charAt(_vm.boundVariable.length-1)==='.')?_c('b-alert',{staticClass:"mt-2",attrs:{"show":"","variant":"danger"}},[_vm._v("Please don't end with a full stop because it messes up grammar of later questions shown to the pariticipant.")]):_vm._e(),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataExport_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b492f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataExport_vue__ = __webpack_require__(497);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74b492f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataExport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b492f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataExport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const trialName = "ORBITA-2";
/* harmony export (immutable) */ __webpack_exports__["a"] = trialName;



/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state === null)?_c('div',[_c('b-button',{staticClass:"mt-4",staticStyle:{"min-width":"12em"},attrs:{"variant":"primary","size":"large"},on:{"click":_vm.onExport}},[_vm._v("Run data export process")])],1):_vm._e(),_vm._v(" "),(_vm.state === 'working')?_c('div',{staticClass:"mt-4 d-flex justify-content-center",staticStyle:{"min-width":"12em"}},[_vm._v("\n    Processing ...\n  ")]):_vm._e(),_vm._v(" "),(_vm.state === 'ready')?_c('div',[_c('b-button',{staticClass:"mt-4",staticStyle:{"min-width":"12em"},attrs:{"variant":"success","size":"large"},on:{"click":_vm.downloadAllFilesAsZip}},[_vm._v("Download")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3",staticStyle:{"min-height":"80vh","display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"}},[(_vm.mode === 'home')?_c('section',{staticStyle:{"margin-left":"1em","margin-right":"1em"}},[_c('AppAutoupdate',{attrs:{"canUpdateNow":true}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","max-width":"18em"}},[_c('br'),_vm._v(" "),_c('h3',[_c('strong',[(_vm.user.privilegesObj.blindedResearcher)?_c('span',[_vm._v("Blinded")]):_vm._e(),_vm._v(" "),(_vm.user.privilegesObj.unblindedResearcher)?_c('span',[_vm._v("Unblinded")]):_vm._e(),_vm._v("\n           Researcher Home\n         ")])]),_vm._v(" "),_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',[_vm._v(" ")]),_vm._v(" "),_c('b-button',{staticClass:"d-flex",staticStyle:{"border-radius":"0.5em"},attrs:{"block":"","size":"lg","variant":"primary"},on:{"click":function($event){return _vm.goOnboardingList()}}},[_c('font-awesome-icon',{staticClass:"mr-4",staticStyle:{"height":"2em","width":"2em"},attrs:{"icon":"handshake"}}),_vm._v(" "),_c('div',{staticClass:"megabutton-text"},[_c('div',{staticClass:"title"},[_vm._v("Set up participant")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Name, phone, dates etc")])])],1),_vm._v(" "),(
           _vm.user.privilegesObj.blindedResearcher ||
           _vm.user.privilegesObj.unblindedResearcher
         )?_c('b-button',{staticClass:"d-flex",staticStyle:{"border-radius":"0.5em"},attrs:{"block":"","size":"lg","variant":"primary"},on:{"click":_vm.goMonitorList}},[_c('div',[_c('font-awesome-icon',{staticClass:"mr-4",staticStyle:{"height":"2em","width":"2em"},attrs:{"icon":"people-carry"}})],1),_vm._v(" "),_c('div',{staticClass:"megabutton-text"},[_c('div',{staticClass:"title"},[_vm._v("Data Monitoring")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Live-Assist or Summary")])])]):_vm._e(),_vm._v(" "),(
           _vm.user.privilegesObj.blindedResearcher ||
           _vm.user.privilegesObj.unblindedResearcher
         )?_c('b-button',{staticClass:"d-flex",staticStyle:{"border-radius":"0.5em"},attrs:{"block":"","size":"lg","variant":"primary"},on:{"click":_vm.goExport}},[_c('svg',{staticClass:"mr-4",staticStyle:{"fill":"white"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"2em","height":"2em","x":"0px","y":"0px","viewBox":"0 0 1000 1000","enable-background":"new 0 0 1000 1000","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"d":"M990,843.9L797.1,694.9V765h-228v157.8l0,0h228V993L990,843.9z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M405.3,913C210.7,902.8,89,854.6,89,796.6V712c68.7,43.2,178.7,73.8,316.3,82.2v-78.6C210.7,705.4,89,657.2,89,599.2v-84.6c81.2,51.1,220.4,84.6,394.8,84.6c79.5,0,151.7-7,214.4-19.4l1.1-76.9c-59.7,11-132.5,17.4-215.5,17.4c-239.8,0-394.8-53-394.8-118.4v-84.6c81.2,51.1,220.4,84.6,394.8,84.6c174.4,0,313.5-33.5,394.8-84.6v84.6c0,34.2-42.4,65-117.1,86.7l62.1,54.4c20.5-8.6,38.9-18.1,55-28.2v76.4l79,69.1V204.4C957.5,95.4,767.2,7,483.8,7C200.3,7,10,95.4,10,204.4v592.2c0,98.6,155.7,180.4,395.3,195L405.3,913L405.3,913z M483.8,86c239.8,0,394.8,53,394.8,118.4c0,65.4-155,118.4-394.8,118.4c-239.8,0-394.8-53-394.8-118.4C89,139,243.9,86,483.8,86z"}})])]),_vm._v(" "),_c('div',{staticClass:"megabutton-text"},[_c('div',{staticClass:"title"},[_vm._v("Export data")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(" ")])])]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.mode === 'onboardingList')?_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":true}}),_vm._v(" "),_c('h3',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goHome()}}},[_c('font-awesome-icon',{attrs:{"icon":"home"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v("\n       Setup\n     ")],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.newParticipantSteps",modifiers:{"newParticipantSteps":true}}],attrs:{"variant":"link"}},[_vm._v("How do I set up a participant?")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"newParticipantSteps"}},[_c('ResViewNewParticipantHelp')],1),_vm._v(" "),_c('b-table',{attrs:{"responsive":"","striped":"","hover":"","items":_vm.presenceArrayEligibleForOnboarding,"fields":_vm.fieldsOnboarding,"sort-by":"dLastLogin","sort-desc":true},on:{"row-clicked":_vm.oneParticipantOnboardingFromItem}})],1):_vm._e(),_vm._v(" "),(_vm.mode === 'onboardingOne')?_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":false}}),_vm._v(" "),_c('h4',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goHome()}}},[_c('font-awesome-icon',{attrs:{"icon":"home"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goOnboardingList()}}},[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v("\n       Set up\n       "+_vm._s(_vm.participant.contactObj.shortName ||
         _vm.participant.presenceObj.emailAtLastLogin ||
         _vm.participant.contactObj.trialId ||
         "one person")+"\n     ")],1),_vm._v(" "),(!_vm.participant.contactObj.shortName)?_c('h5',[_vm._v("\n       "+_vm._s(_vm.participant.presenceObj.emailAtLastLogin)+"\n     ")]):_vm._e(),_vm._v(" "),_c('b-form',[_c('br'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Activate as a participant","label-size":"lg","label-class":"font-weight-bold"}},[_c('b-form-checkbox',{on:{"change":function($event){_vm.participant.privilegesRef
               .child('participant')
               .set(_vm.participant.privilegesObj.participant)}},model:{value:(_vm.participant.privilegesObj.participant),callback:function ($$v) {_vm.$set(_vm.participant.privilegesObj, "participant", $$v)},expression:"participant.privilegesObj.participant"}},[_vm._v("Is a trial participant")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"71%"}},[_vm._v("\n           i.e. allow them to access symptom entry module\n         ")]),_vm._v(" "),(_vm.participant.privilegesObj.participant)?_c('div',[_c('b-form-checkbox',{on:{"change":function($event){_vm.participant.privilegesRef
                 .child('participantCompleted')
                 .set(_vm.participant.privilegesObj.participantCompleted)}},model:{value:(_vm.participant.privilegesObj.participantCompleted),callback:function ($$v) {_vm.$set(_vm.participant.privilegesObj, "participantCompleted", $$v)},expression:"participant.privilegesObj.participantCompleted"}},[_vm._v("Has completed participation")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"71%"}},[_vm._v("i.e. omit from daily chasing-up list")])],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),(_vm.participant.privilegesObj.participant === true)?_c('div',[(
             !_vm.participant.statusObj.privacy ||
             !_vm.participant.statusObj.privacy.agree
           )?_c('div',[_c('b-alert',{attrs:{"show":"","variant":"primary"}},[_c('h3',[_vm._v("Ask them to read their privacy policy")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("They can do that while you continue setting them up.")])])],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Identity","label-size":"lg","label-class":"font-weight-bold"}},[_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v("\n               Email\n               "),_c('span',{staticStyle:{"font-size":"70%"}},[_vm._v("non-editable")])]),_vm._v(" "),_c('b-col',[_c('span',{staticStyle:{"color":"gray"}},[_vm._v(_vm._s(_vm.participant.presenceObj.emailAtLastLogin))])])],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Short name","description":"Will show at top of their screen."}},[_c('b-form-input',{attrs:{"type":"text","required":"","placeholder":"e.g. Bill"},on:{"change":function($event){_vm.participant.contactRef
                   .child('shortName')
                   .set(_vm.participant.contactObj.shortName)}},model:{value:(_vm.participant.contactObj.shortName),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "shortName", $$v)},expression:"participant.contactObj.shortName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Trial ID"}},[_c('b-form-input',{attrs:{"type":"text","required":""},on:{"change":function($event){_vm.participant.contactRef
                   .child('trialId')
                   .set(_vm.participant.contactObj.trialId)}},model:{value:(_vm.participant.contactObj.trialId),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "trialId", $$v)},expression:"participant.contactObj.trialId"}})],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"vertical":"","label":"Phone numbers","label-size":"lg","label-class":"font-weight-bold"}},[_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("Mobile")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","required":""},on:{"change":function($event){_vm.participant.contactRef
                     .child('mobileSelf')
                     .set(_vm.participant.contactObj.mobileSelf)}},model:{value:(_vm.participant.contactObj.mobileSelf),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "mobileSelf", $$v)},expression:"participant.contactObj.mobileSelf"}})],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("Home landline")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","placeholder":"optional"},on:{"change":function($event){_vm.participant.contactRef
                     .child('homeLandline')
                     .set(_vm.participant.contactObj.homeLandline)}},model:{value:(_vm.participant.contactObj.homeLandline),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "homeLandline", $$v)},expression:"participant.contactObj.homeLandline"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("Alternative contact's mobile")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","placeholder":"optional"},on:{"change":function($event){_vm.participant.contactRef
                     .child('mobileAlternative')
                     .set(_vm.participant.contactObj.mobileAlternative)}},model:{value:(_vm.participant.contactObj.mobileAlternative),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "mobileAlternative", $$v)},expression:"participant.contactObj.mobileAlternative"}})],1)],1),_vm._v(" "),(_vm.participant.contactObj.mobileAlternative)?_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("Who is alt contact?")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","placeholder":"e.g. wife Sylvia"},on:{"change":function($event){_vm.participant.contactRef
                     .child('mobileAlternativeWho')
                     .set(_vm.participant.contactObj.mobileAlternativeWho)}},model:{value:(_vm.participant.contactObj.mobileAlternativeWho),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "mobileAlternativeWho", $$v)},expression:"participant.contactObj.mobileAlternativeWho"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"What is your angina like?","label-size":"lg","label-class":"font-weight-bold"}},[_c('div',[_vm._v("\n             Examples of desired grammatical structure of an answer:\n             "),_c('ul',[_c('li',[_vm._v("\n                 a pin-point pain in\n                 "),_c('strong',[_vm._v("my")]),_vm._v(" right ear\n               ")]),_vm._v(" "),_c('li',[_vm._v("\n                 itchiness of\n                 "),_c('strong',[_vm._v("my")]),_vm._v(" left foot\n               ")])])]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":""},on:{"change":function($event){_vm.participant.contactRef
                 .child('myAnginaIs')
                 .set(_vm.participant.contactObj.myAnginaIs)}},model:{value:(_vm.participant.contactObj.myAnginaIs),callback:function ($$v) {_vm.$set(_vm.participant.contactObj, "myAnginaIs", $$v)},expression:"participant.contactObj.myAnginaIs"}}),_vm._v(" "),(
               _vm.participant.contactObj.myAnginaIs &&
               _vm.participant.contactObj.myAnginaIs.charAt(0).toLowerCase() !==
                 _vm.participant.contactObj.myAnginaIs.charAt(0)
             )?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("Please don't capitalise as it messes up the help\n             message.")]):_vm._e(),_vm._v(" "),(
               _vm.participant.contactObj.myAnginaIs &&
               _vm.participant.contactObj.myAnginaIs.charAt(
                 _vm.participant.contactObj.myAnginaIs.length - 1
               ) === '.'
             )?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("Please don't end with a full stop. We automatically add one when\n             putting in a sentence.")]):_vm._e(),_vm._v(" "),(_vm.participant.contactObj.myAnginaIs)?_c('div',[_vm._v("\n             The participant's help message will be this:\n             "),_c('MyAnginaIs',{attrs:{"text":_vm.participant.contactObj.myAnginaIs}})],1):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Activities","label-size":"lg","label-class":"font-weight-bold"}},[_c('b-form-row',{staticClass:"align-items-center"},[_c('ResViewAnginaTrigger',{attrs:{"text":"Mild activity is ...","fbRef":_vm.participant.contactRef.child('windows/questions/activity_001')}})],1),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center"},[_c('ResViewAnginaTrigger',{attrs:{"text":"Moderate activity is ...","fbRef":_vm.participant.contactRef.child('windows/questions/activity_002')}})],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Days of symptoms to capture","label-size":"lg","label-class":"font-weight-bold"}},[_c('b-form-row',{staticClass:"align-items-center",staticStyle:{"padding-bottom":"0.3em"}},[_c('b-col',[_c('strong',[_vm._v("First")]),_vm._v(" day being recorded\n               ")]),_vm._v(" "),_c('b-col',[_c('v-date-picker',{attrs:{"onkeydown":"return false","value":new Date(_vm.participant.contactObj.startDateKey) || new Date(),"formats":_vm.datePickerFormats},on:{"dayclick":function (dObj) {
                     _vm.participant.contactRef
                       .child('startDateKey')
                       .set(_vm.convertFromDateObjToDateKey(dObj.date));
                   }}})],1),_vm._v(" "),(_vm.participant.contactObj.startDateKey)?_c('b-col',[_c('b-button',{staticClass:"btn-sm btn-success",on:{"click":function($event){return _vm.fillPrerandomizationWindows(_vm.participant)}}},[_vm._v("Fill baseline 2 weeks")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('b-form-row',[_c('b-col',[_c('small',[_vm._v("After entering the first day, click \"Fill\" button rather\n                   than manually calculating, because ~1/3 of manual\n                   calculations are wrong. Humans are vulnerable to fencepost\n                   errors.")])])],1)],1),_vm._v(" "),_vm._l((_vm.windowKeys),function(windowKey,iWindow){return _c('div',{key:windowKey,staticClass:"align-items-center",staticStyle:{"padding-bottom":"0.3em"}},[(iWindow === 2)?_c('div',[_c('b-form-row',{staticStyle:{"color":"red","font-weight":"900","font-size":"200%"}},[_vm._v(" STOP")]),_vm._v(" "),_c('b-form-row',{staticStyle:{"color":"red","font-weight":"700"}},[_vm._v(" When initially setting up the patient, DO NOT fill in\n                 any dates below.")]),_vm._v(" "),_c('b-form-row',{staticStyle:{"color":"red","font-weight":"700"}},[_vm._v(" Wait until the randomized, blinded procedure is\n                 actually happening.")]),_vm._v(" "),_c('b-form-row',[_vm._v("\n                  Even if you  \n                 "),_c('em',[_vm._v("think")]),_vm._v("   you know the future date of the\n                 procedure, don't enter it in advance.\n               ")]),_vm._v(" "),_c('b-form-row',[_vm._v(" ")])],1):_vm._e(),_vm._v(" "),_c('b-form-row',[_c('b-col',[_vm._v("Last day of "+_vm._s(_vm.windowDisplayNames[iWindow])+_vm._s(_vm.windowDurationIfAvailable(windowKey)))]),_vm._v(" "),_c('b-col',[_c('v-date-picker',{attrs:{"onkeydown":"return false","value":new Date(
                       _vm.participant.contactObj.windows &&
                         _vm.participant.contactObj.windows.dates &&
                         _vm.participant.contactObj.windows.dates[windowKey] &&
                         _vm.participant.contactObj.windows.dates[windowKey]
                           .endDateKey
                     ),"formats":_vm.datePickerFormats},on:{"dayclick":function (dObj) {
                       _vm.participant.contactRef
                         .child('windows/dates')
                         .child(windowKey)
                         .child('endDateKey')
                         .set(_vm.convertFromDateObjToDateKey(dObj.date));
                     }}})],1),_vm._v(" "),_c('b-col',[(
                     _vm.participant.contactObj.windows &&
                     _vm.participant.contactObj.windows.dates &&
                     _vm.participant.contactObj.windows.dates[windowKey] &&
                     _vm.participant.contactObj.windows.dates[windowKey]
                       .endDateKey &&
                     iWindow >= 2
                   )?_c('b-button',{staticClass:"btn-sm btn-light",on:{"click":function($event){return _vm.fillDownWeekly(_vm.participant, windowKey)}}},[_vm._v("Fill down weekly")]):_vm._e()],1)],1),_vm._v(" "),(iWindow === 2)?_c('div',[_c('b-form-row',{staticStyle:{"font-size":"71%"}},[_vm._v("  After this date, unblinded researchers can no\n                 longer access this participant")]),_vm._v(" "),_c('br')],1):_vm._e()],1)})],2)],1):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","size":"lg"},on:{"click":function($event){return _vm.goOnboardingList()}}},[_vm._v("    OK    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Advanced stuff, rarely needed","label-size":"lg","label-class":"font-weight-bold"}},[_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("Authentication Id")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.id))])],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.participant.statusObj && _vm.participant.statusObj.trained)?_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("If they have forgotten how to use this app")]),_vm._v(" "),_c('b-col',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.participant.statusRef.child('trained').set(false);
                 _vm.triggerParticipantScreenRefresh();}}},[_vm._v("Force them to redo training")])],1)],1):_vm._e(),_vm._v(" "),(_vm.participant.statusObj && !_vm.participant.statusObj.trained)?_c('b-form-row',{staticClass:"align-items-center"},[_c('b-col',[_vm._v("If they don't need training")]),_vm._v(" "),_c('b-col',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.participant.statusRef.child('trained').set(true);
                 _vm.triggerParticipantScreenRefresh();}}},[_vm._v("Skip training")])],1)],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.mode === 'monitorList')?_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":true}}),_vm._v(" "),_c('h3',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goHome()}}},[_c('font-awesome-icon',{attrs:{"icon":"home"}})],1),_vm._v("Data Monitoring\n     ")],1),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.onlyShowOrbita2),callback:function ($$v) {_vm.onlyShowOrbita2=$$v},expression:"onlyShowOrbita2"}},[_vm._v("Only Ids containing \"ORBITA2\"")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.onlyShowIncomplete),callback:function ($$v) {_vm.onlyShowIncomplete=$$v},expression:"onlyShowIncomplete"}},[_vm._v("Only show participants still in trial")]),_vm._v(" "),_c('b-table',{staticStyle:{"table-layout":"fixed","word-break":"break-word"},attrs:{"striped":"","hover":"","items":_vm.participantMingledAccessibleByResearcher,"fields":_vm.fieldsMonitor,"sort-by":"completeToDateKey"},scopedSlots:_vm._u([{key:"cell(actions)",fn:function(thingContainingItem){return [_c('b-button',{staticClass:"m-1",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.goMonitorOneFromItem(thingContainingItem.item)}}},[_vm._v("Live-assist")]),_vm._v(" "),_c('b-button',{staticClass:"m-1",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.goDisplayOneFromItem(thingContainingItem.item)}}},[_vm._v("Summary")])]}}],null,false,4114601772)})],1):_vm._e(),_vm._v(" "),(
       _vm.mode === 'monitorOne' &&
       _vm.participant.privilegesIsLoaded &&
       _vm.participant.statusIsLoaded &&
       _vm.participant.contactIsLoaded
     )?_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":false}}),_vm._v(" "),_c('h4',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goHome()}}},[_c('font-awesome-icon',{attrs:{"icon":"home"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goMonitorList()}}},[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v("\n       Live-assist\n     ")],1),_vm._v(" "),_c('h6',{staticClass:"mx-2"},[_vm._v("\n       "+_vm._s(_vm.participant.contactObj.trialId)+"\n        \n       "),_c('b-button',{attrs:{"variant":"success"}},[_c('a',{staticStyle:{"color":"white"},attrs:{"href":'tel:' + _vm.participant.contactObj.mobileSelf}},[_vm._v("\n           "+_vm._s(_vm.participant.contactObj.mobileSelf)+"  \n           "),_c('font-awesome-icon',{attrs:{"icon":"phone"}})],1)]),_vm._v(" \n       "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.showAlternateContacts",modifiers:{"showAlternateContacts":true}}],attrs:{"variant":"outline-primary"}},[_vm._v("Alt Contact")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"showAlternateContacts"}},[_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v("Email")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.presenceObj.emailAtLastLogin))])],1),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v("Home landline")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.presenceObj.homeLandline || "none given"))])],1),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v(_vm._s(_vm.participant.contactObj.mobileAlternativeWho || "Alternative contact"))]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.contactObj.mobileAlternative || "none given"))])],1)],1),_vm._v(" "),_c('div',{staticClass:"phone-aspect-ratio-container"},[_c('div',{staticClass:"phone-outer"},[_c('div',{staticClass:"phone-inner"},[(_vm.participant.statusObj.trained)?_c('div',[_c('HeaderBand',{attrs:{"name":typeof _vm.participant.contactObj.shortName === 'string'
                   ? _vm.participant.contactObj.shortName
                   : 'Name not given yet'}}),_vm._v(" "),_c('SymptomEntry',{attrs:{"participant":_vm.participant,"entryMode":"live"}})],1):_c('div',[_c('HeaderBand',{attrs:{"name":"Practice Mode"}}),_vm._v(" "),_c('SymptomEntry',{attrs:{"participant":_vm.participant,"entryMode":"practice"}})],1)])])]),_vm._v(" "),_c('p',{staticClass:"m-2"},[_vm._v("\n       If speaking to participant, remember their screen(s) may have different\n       size, shape and orientation, so (for example) they may need to scroll\n       even when you don't.\n     ")])],1):_vm._e(),_vm._v(" "),(
       _vm.mode === 'displayOne' &&
       _vm.participant.privilegesIsLoaded &&
       _vm.participant.statusIsLoaded &&
       _vm.participant.contactIsLoaded
     )?_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":false}}),_vm._v(" "),_c('h4',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goHome()}}},[_c('font-awesome-icon',{attrs:{"icon":"home"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.goMonitorList()}}},[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" "),_c('span',{staticClass:"divider"},[_vm._v("| ")]),_vm._v("\n       Summary of data history\n     ")],1),_vm._v(" "),_c('h6',{staticClass:"mx-2"},[_vm._v("\n       "+_vm._s(_vm.participant.contactObj.trialId)+"\n        \n       "),_c('b-button',{attrs:{"variant":"success"}},[_c('a',{staticStyle:{"color":"white"},attrs:{"href":'tel:' + _vm.participant.contactObj.mobileSelf}},[_vm._v("\n           "+_vm._s(_vm.participant.contactObj.mobileSelf)+"  \n           "),_c('font-awesome-icon',{attrs:{"icon":"phone"}})],1)]),_vm._v(" \n       "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.showAlternateContacts",modifiers:{"showAlternateContacts":true}}],attrs:{"variant":"outline-primary"}},[_vm._v("Alt Contact")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"showAlternateContacts"}},[_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v("Email")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.presenceObj.emailAtLastLogin))])],1),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v("Home landline")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.presenceObj.homeLandline || "none given"))])],1),_vm._v(" "),_c('b-form-row',{staticClass:"align-items-center mb-3"},[_c('b-col',[_vm._v(_vm._s(_vm.participant.contactObj.mobileAlternativeWho || "Alternative contact"))]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.participant.contactObj.mobileAlternative || "none given"))])],1)],1),_vm._v(" "),_c('HeaderBand',{attrs:{"name":typeof _vm.participant.contactObj.shortName === 'string'
           ? _vm.participant.contactObj.shortName
           : 'Name not given yet'}}),_vm._v(" "),(
         _vm.participant && _vm.participant.statusObj && _vm.participant.statusObj.live
       )?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.participant.contactObj.trialId))]),_vm._v(" "),_c('h4',[_vm._v("Daily data")]),_vm._v(" "),_c('div',[_vm._v("Date, Yes or No, Frequency, Severity (out of 600)")]),_vm._v(" "),_vm._l(((_vm.participant.statusObj.live || {}).days),function(dayData,dayKey){return _c('div',{key:dayKey},[_vm._v("\n         "+_vm._s(dayKey)+",\n\n         "),_c('span',{class:{
             emphasise: dayData.anginaCount > 0,
           }},[_vm._v(_vm._s(dayData.anginaYesNo)+",\n           "+_vm._s(dayData.anginaCount || 0)+"\n           ,\n           "+_vm._s(dayData.anginaSeverity || 0))]),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Long-window data (e.g. weekly)")]),_vm._v(" "),_c('div',[_vm._v("Window, Activity, Yes or No")]),_vm._v(" "),_vm._l(((_vm.participant.statusObj.live || {})
           .windows),function(windowData,windowKey){return _c('div',{key:windowKey},_vm._l((windowData.questions),function(activityData,activityKey){return _c('div',{key:activityKey},[_vm._v("\n           "+_vm._s(_vm.windowKeyToDisplayName(windowKey))+", "+_vm._s(activityKey)+",\n           "),_c('span',{class:{
               emphasise: activityData.anginaYesNo === 'Yes',
             }},[_vm._v("\n             "+_vm._s(activityData.anginaYesNo)+"\n           ")])])}),0)})],2):_c('div',[_c('h4',[_vm._v("No data")])])],1):_vm._e(),_vm._v(" "),(_vm.mode === 'export')?_c('section',[_c('h3',[_c('b-button',{attrs:{"id":"researcher-home-button","variant":"link"},on:{"click":function($event){return _vm.goHome()}}},[_c('font-awesome-icon',{attrs:{"icon":"home"}})],1),_vm._v("Data Export\n     ")],1),_vm._v(" "),_c('DataExport',{attrs:{"participantIdArray":_vm.participantIdArray,"contactRootObj":_vm.contactRootObj,"statusRootRef":_vm.statusRootRef}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHelp_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a74c170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHelp_vue__ = __webpack_require__(501);
function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHelp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a74c170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHelp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3"},[_c('div',{staticClass:"d-flex flex-row justify-content-between"},[_vm._v("\n     \n    "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapseHelp",modifiers:{"collapseHelp":true}}],attrs:{"variant":"link","size":"sm"},on:{"click":_vm.scrollHelpIntoView}},[_vm._v("\n      Help")])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapseHelp"}},[_c('h2',{attrs:{"id":"scrollTarget"}},[_vm._v("Help")]),_vm._v(" "),(_vm.privileges.blindedResearcher)?_c('b-alert',{attrs:{"show":"","variant":"primary"}},[_vm._v("You are a blinded researcher. The help below is the outline of the\n      layout seen by the last participant you accessed. If you don't currently\n      have a participant open above, you can ignore any error messages about\n      missing information.")]):_vm._e(),_vm._v(" "),(_vm.privileges.unblindedResearcher)?_c('b-alert',{attrs:{"show":"","variant":"primary"}},[_vm._v("You are an "),_c('strong',[_vm._v("unblinded")]),_vm._v(" researcher, so remember you only\n      have access to participants before they are randomized. The help below\n      is the outline of the layout seen by the last participant you accessed.\n      If you don't currently have a participant open above, you can ignore any\n      error messages about missing information.")]):_vm._e(),_vm._v(" "),_c('MyAnginaIs',{attrs:{"text":_vm.myAnginaIs}}),_vm._v(" "),_c('p',[_vm._v("\n      Use this App every day throughout the trial to report the symptoms you\n      had the day before. Once a week, the App will additionally ask whether\n      you get angina when you\n      "+_vm._s(_vm.windowsQuestions.activity_001 ||
        "** SOME IMPORTANT INFORMATION IS MISSING. PLEASE CONTACT THE ORBITA TEAM AND ASK THEM TO 'SET UP YOUR WEEKLY ACTIVITY DESCRIPTION' **")+"\n      and when you\n      "+_vm._s(_vm.windowsQuestions.activity_002 ||
        "** SOME IMPORTANT INFORMATION IS MISSING. PLEASE CONTACT THE ORBITA TEAM AND ASK THEM TO 'SET UP YOUR WEEKLY ACTIVITY DESCRIPTION' **")+". The App will say when you are up to date with data entry.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("What happens if I miss a day?")]),_vm._v(" "),_c('p',[_vm._v("\n      If you miss a day, for example from lack of internet access, you can\n      enter the data later. Our team will phone you if there is too much\n      delay.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("\n      Do I count episodes of angina I get when I\n      "+_vm._s(_vm.windowsQuestions.activity_001)+" or\n      "+_vm._s(_vm.windowsQuestions.activity_002)+"?\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Yes, include such episodes within your daily angina counts. Then at the\n      weekly question about angina during those specific activities, please\n      answer yes. When we process the data, we know not to double-count the\n      answers to the weekly questions as extra episodes.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("How do I use the mild-moderate-severe slider?")]),_vm._v(" "),_c('p',[_vm._v("\n      Use the slider to record your personal opinion on the severity of the\n      angina you had on the day being asked about. This is a personal\n      judgement for you to make at the time you are asked. We expect the way\n      you make these judgements may naturally change over the course of the\n      study. We are asking your independent view on how you feel each day.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("What happens if I make a mistake?")]),_vm._v(" "),_c('p',[_vm._v("\n      Make a note of what you intended to enter and then call our helpline.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Why can't I see my previous entries?")]),_vm._v(" "),_c('p',[_vm._v("\n      During the trial we need your independent answers from the separate days\n      and therefore the app does not show previous entries. After you finish\n      the trial, we can show you all your entries.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("What if the app isn’t working properly?")]),_vm._v(" "),_c('p',[_vm._v("Please call our helpline.")]),_vm._v(" "),_c('h4',[_vm._v("What should I do if I don’t feel well?")]),_vm._v(" "),_c('p',[_vm._v("\n      If you want to discuss this with us, please call our helpline at any\n      time.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Helpline number")]),_vm._v(" "),_c('p',[_vm._v("07885587409")]),_vm._v(" "),_c('h4',[_vm._v("Advanced Tools")]),_vm._v(" "),_c('p',[_vm._v("\n      ORBITA staff may ask you to click this button\n      "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapseAdvanced",modifiers:{"collapseAdvanced":true}}],attrs:{"b-button":"","size":"sm","variant":"outline-primary"}},[_vm._v("Advanced Tools")])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapseAdvanced"}},[_c('b-alert',{attrs:{"variant":"light","show":""}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('h5',[_vm._v("About your device")])]),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"half"},[_vm._v("This device thinks the GMT date and time is:")]),_vm._v(" "),_c('div',{staticClass:"half"},[_vm._v(_vm._s(new Date().toUTCString()))])]),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"half"},[_vm._v("\n            The device's operating system reports the time zone as:\n          ")]),_vm._v(" "),_c('div',{staticClass:"half"},[_vm._v("\n            "+_vm._s(Intl.DateTimeFormat().resolvedOptions().timeZone)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"half"},[_vm._v("\n            Based on the above, it reports the local time to be:\n          ")]),_vm._v(" "),_c('div',{staticClass:"half"},[_vm._v(_vm._s(new Date().toLocaleString()))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('h5',[_vm._v("About the App")])]),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"half"},[_vm._v("App on your device was built at:")]),_vm._v(" "),_c('div',{staticClass:"half"},[_vm._v(_vm._s(_vm.buildVersion))])]),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"half"},[_vm._v("Your unique user ID:")]),_vm._v(" "),_c('div',{staticClass:"half"},[_vm._v(_vm._s(_vm.userId))])]),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"half"},[_vm._v("If asked to log out of the App:")]),_vm._v(" "),_c('div',{staticClass:"half"},[_c('b-button',{attrs:{"variant":"outline-dark"},on:{"click":function($event){return _vm.$emit('trySignOut')}}},[_vm._v("Log out")])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapseAdvanced",modifiers:{"collapseAdvanced":true}}],attrs:{"b-button":"","size":"sm","variant":"outline-primary"}},[_vm._v("\n          Close Advanced Tools\n        ")]),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('div',{staticClass:"my-2 d-flex flex-row justify-content-between",staticStyle:{"width":"100%"}},[_c('div',[_vm._v(" ")]),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapseHelp",modifiers:{"collapseHelp":true}}],attrs:{"block":"","variant":"primary"}},[_vm._v("Close Help")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionSheet_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdf5a818_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionSheet_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionSheet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdf5a818_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionSheet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

// a mini defer like angular's $q.defer()
// Used for the ACTIONSHEET.vue component

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var promise;
  var resolve;
  var reject;

  /* eslint-disable-next-line promise/param-names */
  promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (_resolve_, _reject_) {
    resolve = _resolve_;
    reject = _reject_;
  });

  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
});

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"after-leave":_vm.afterLeave}},[(_vm.showModal)?_c('div',{staticClass:"ios-actionsheet-overlay",on:{"click":_vm.deactivate}},[_c('div',{staticClass:"ios-actionsheet"},_vm._l((_vm.groups),function(group,groupIndex){return _c('div',{key:groupIndex,staticClass:"ios-actionsheet-group"},_vm._l((group),function(button,index){return _c('div',{key:index,class:{'ios-actionsheet-label': button.label, 'ios-actionsheet-button': !button.label, 'ios-actionsheet-button-color': button.color, 'ios-actionsheet-button-bold': button.bold, 'ios-actionsheet-button-disable': button.disable},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onClick(button, index, groupIndex)}}},[_vm._v(_vm._s(button.text))])}),0)}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.amOnline === false)?_c('section',[_c('AppOfflineWarning')],1):_vm._e(),_vm._v(" "),(_vm.loggedState !== 'in')?_c('section',[_c('AppAutoupdate',{attrs:{"canUpdateNow":true}})],1):_vm._e(),_vm._v(" "),(_vm.loggedState === undefined)?_c('section',{staticClass:"center-container"},[_c('img',{staticStyle:{"width":"50vw"},attrs:{"src":__webpack_require__(158),"alt":"Orbita-2 Logo"}})]):_vm._e(),_vm._v(" "),(_vm.loggedState === 'out')?_c('section',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main"},[_c('b-form',{on:{"submit":function($event){return _vm.tryLogin(_vm.email, _vm.password)}}},[_c('h2',[_vm._v("Please log in")]),_vm._v(" "),(_vm.loginErr.message)?_c('div',{staticClass:"err-font err-container"},[_c('br'),_vm._v("\n            "+_vm._s(_vm.loginErr.message)+"\n            "),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"px-3",staticStyle:{"font-family":"'Courier New', monospace"}},[_c('b-input',{staticStyle:{"width":"100%","padding":"0.5em"},attrs:{"placeholder":"email","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-input',{staticStyle:{"width":"100%","padding":"0.5em"},attrs:{"type":"password","placeholder":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":function($event){return _vm.tryLogin(_vm.email, _vm.password)}}},[_vm._v("Log in")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){return _vm.tryForgotPassword(_vm.email)}}},[_vm._v("Forgot password")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center"}},[_c('SpinnerTrinity')],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Joining the trial?")]),_vm._v(" "),_c('div',{staticStyle:{"max-width":"20em","margin":"auto","text-align":"left"}},[_c('ul',[(!(_vm.email.includes('@') && _vm.email.includes('.')))?_c('li',[_vm._v("\n                Enter your email above.\n              ")]):_vm._e(),_vm._v(" "),(_vm.password.length < 6)?_c('li',[_vm._v("\n                Create a password"),_c('br'),_vm._v("(at least 6 characters)\n              ")]):_vm._e(),_vm._v(" "),_c('li',[_vm._v("\n                Click here >\n                "),_c('b-button',{staticClass:"btn btn-secondary",attrs:{"size":"small"},on:{"click":function($event){return _vm.trySignup(_vm.email, _vm.password)}}},[_vm._v("Enrol me")])],1)])])],1)],1)]):_vm._e(),_vm._v(" "),(
        _vm.loggedState === 'in' && _vm.user.privilegesIsLoaded && _vm.user.contactIsLoaded
      )?_c('div',[(
          !_vm.user.privilegesObj.participant &&
          !_vm.user.privilegesObj.blindedResearcher &&
          !_vm.user.privilegesObj.unblindedResearcher
        )?_c('section',{staticStyle:{"min-height":"90vh"}},[_c('AppAwaitingApproval')],1):_vm._e(),_vm._v(" "),(
          _vm.user.privilegesObj.participant &&
          _vm.participant.privilegesIsLoaded &&
          _vm.participant.statusIsLoaded &&
          _vm.participant.contactIsLoaded
        )?_c('section',[(_vm.participantSufficientInfo.all)?_c('div',{staticStyle:{"min-height":"90vh"}},[(_vm.participant.statusObj.trained)?_c('div',[_c('HeaderBand',{attrs:{"name":typeof _vm.participant.contactObj.shortName === 'string'
                  ? _vm.participant.contactObj.shortName
                  : 'Name not given yet'}}),_vm._v(" "),_c('SymptomEntry',{attrs:{"participant":_vm.participant,"entryMode":"live"}})],1):_c('div',[_c('HeaderBand',{attrs:{"name":"Practice Mode"}}),_vm._v(" "),_c('SymptomEntry',{attrs:{"participant":_vm.participant,"entryMode":"practice"}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(
          _vm.user.privilegesObj.blindedResearcher ||
          _vm.user.privilegesObj.unblindedResearcher
        )?_c('section',{staticStyle:{"min-height":"90vh"}},[_c('HeaderBand',{attrs:{"name":_vm.user.contactObj.shortName,"privileges":_vm.user.privilegesObj,"email":_vm.user.presenceObj.emailAtLastLogin}}),_vm._v(" "),_c('ResView',{attrs:{"user":_vm.user,"participant":_vm.participant,"bindParticipantToAUserId":_vm.bindParticipantToAUserId}})],1):_vm._e(),_vm._v(" "),(
          !_vm.participantSufficientInfo.all &&
          _vm.participant.statusIsLoaded &&
          _vm.user.privilegesObj.participant
        )?_c('section',{staticStyle:{"min-height":"90vh"}},[_c('AppPrivacy',{attrs:{"displayName":_vm.user.contactObj.shortName,"participantSufficientInfo":_vm.participantSufficientInfo},on:{"gave-permission":function($event){_vm.participant.statusRef.child('privacy/agree').set('yes');
            _vm.participant.statusRef
              .child('privacy/agreeDate')
              .set(new Date().toISOString());},"refused-permission":function($event){return _vm.trySignOut()}}})],1):_vm._e(),_vm._v(" "),_c('AppHelp',{attrs:{"myAnginaIs":_vm.participant.contactObj.myAnginaIs,"userId":_vm.user.id,"windowsQuestions":_vm.participant.contactObj.windows.questions,"privileges":_vm.user.privilegesObj},on:{"trySignOut":_vm.trySignOut}})],1):_vm._e(),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logged-out"},[_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"max-width":"15em","max-height":"100%"},attrs:{"src":__webpack_require__(158),"alt":"Orbita-2 Logo"}})]),_vm._v(" "),_c('div',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_vm._v("\n\n"),_vm._v("\n\n")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return systemStatusRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return amOnlineRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return contactRootRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return privilegesRootRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return presenceRootRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return statusRootRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return logRootRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return debugRootRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerValueTIMESTAMP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
// Idea for a separate firebase.js file came from here:
// https://www.youtube.com/watch?v=831zOI02Q_0



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: "AIzaSyDwti_8lx29vSbIiQO9mBHGtm2T03U0JsE",
  authDomain: "o2a-orbita-2.firebaseapp.com",
  databaseURL: "https://o2a-orbita-2.firebaseio.com",
  projectId: "o2a-orbita-2",
  storageBucket: "o2a-orbita-2.appspot.com",
  messagingSenderId: "169579685982"
});
var auth = firebaseApp.auth();
var db = firebaseApp.database();

// Globals
var systemStatusRef = db.ref("rAll-wHq/systemStatus");
var amOnlineRef = db.ref(".info/connected");

// These roots then have branches per user
var contactRootRef = db.ref("contacts");
var privilegesRootRef = db.ref("privileges");
var presenceRootRef = db.ref("presence");
var statusRootRef = db.ref("status");
var logRootRef = db.ref("log");
var debugRootRef = db.ref("debug");

// General constants
var ServerValueTIMESTAMP = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database.ServerValue.TIMESTAMP;

/***/ })

},[348]);


// WEBPACK FOOTER //
// static/js/app.59a6f237c900342543cb.js